var Si = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
};
var Vn = (e, t, r) => (Si(e, t, "read from private field"), r ? r.call(e) : t.get(e)), _i = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Ti = (e, t, r, n) => (Si(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
function dt(e, t) {
  const r = /* @__PURE__ */ Object.create(null), n = e.split(",");
  for (let o = 0; o < n.length; o++)
    r[n[o]] = !0;
  return t ? (o) => !!r[o.toLowerCase()] : (o) => !!r[o];
}
const X = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Kt = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], ce = () => {
}, ea = () => !1, Fl = /^on[^a-z]/, Cr = (e) => Fl.test(e), $r = (e) => e.startsWith("onUpdate:"), $ = Object.assign, Yo = (e, t) => {
  const r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}, Bl = Object.prototype.hasOwnProperty, k = (e, t) => Bl.call(e, t), R = Array.isArray, At = (e) => dn(e) === "[object Map]", ta = (e) => dn(e) === "[object Set]", V = (e) => typeof e == "function", ne = (e) => typeof e == "string", Qo = (e) => typeof e == "symbol", Z = (e) => e !== null && typeof e == "object", Jo = (e) => Z(e) && V(e.then) && V(e.catch), ra = Object.prototype.toString, dn = (e) => ra.call(e), Xo = (e) => dn(e).slice(8, -1), na = (e) => dn(e) === "[object Object]", Zo = (e) => ne(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, zr = /* @__PURE__ */ dt(
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Ll = /* @__PURE__ */ dt(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), hn = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (r) => t[r] || (t[r] = e(r));
}, kl = /-(\w)/g, Xt = hn((e) => e.replace(kl, (t, r) => r ? r.toUpperCase() : "")), zl = /\B([A-Z])/g, ut = hn(
  (e) => e.replace(zl, "-$1").toLowerCase()
), mn = hn(
  (e) => e.charAt(0).toUpperCase() + e.slice(1)
), vt = hn(
  (e) => e ? `on${mn(e)}` : ""
), vr = (e, t) => !Object.is(e, t), or = (e, t) => {
  for (let r = 0; r < e.length; r++)
    e[r](t);
}, Gr = (e, t, r) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    value: r
  });
}, Ul = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
let Pi;
const en = () => Pi || (Pi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function gn(e) {
  if (R(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++) {
      const n = e[r], o = ne(n) ? Kl(n) : gn(n);
      if (o)
        for (const i in o)
          t[i] = o[i];
    }
    return t;
  } else {
    if (ne(e))
      return e;
    if (Z(e))
      return e;
  }
}
const Hl = /;(?![^(]*\))/g, ql = /:([^]+)/, Wl = /\/\*[^]*?\*\//g;
function Kl(e) {
  const t = {};
  return e.replace(Wl, "").split(Hl).forEach((r) => {
    if (r) {
      const n = r.split(ql);
      n.length > 1 && (t[n[0].trim()] = n[1].trim());
    }
  }), t;
}
function xe(e) {
  let t = "";
  if (ne(e))
    t = e;
  else if (R(e))
    for (let r = 0; r < e.length; r++) {
      const n = xe(e[r]);
      n && (t += n + " ");
    }
  else if (Z(e))
    for (const r in e)
      e[r] && (t += r + " ");
  return t.trim();
}
const Yl = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", Ql = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", Jl = /* @__PURE__ */ dt(Yl), Xl = /* @__PURE__ */ dt(Ql), Zl = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", $l = /* @__PURE__ */ dt(Zl);
function oa(e) {
  return !!e || e === "";
}
const Ft = (e) => ne(e) ? e : e == null ? "" : R(e) || Z(e) && (e.toString === ra || !V(e.toString)) ? JSON.stringify(e, ia, 2) : String(e), ia = (e, t) => t && t.__v_isRef ? ia(e, t.value) : At(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce((r, [n, o]) => (r[`${n} =>`] = o, r), {})
} : ta(t) ? {
  [`Set(${t.size})`]: [...t.values()]
} : Z(t) && !R(t) && !na(t) ? String(t) : t;
function bo(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Ie;
class Gl {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = Ie, !t && Ie && (this.index = (Ie.scopes || (Ie.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(t) {
    if (this._active) {
      const r = Ie;
      try {
        return Ie = this, t();
      } finally {
        Ie = r;
      }
    } else
      process.env.NODE_ENV !== "production" && bo("cannot run an inactive effect scope.");
  }
  on() {
    Ie = this;
  }
  off() {
    Ie = this.parent;
  }
  stop(t) {
    if (this._active) {
      let r, n;
      for (r = 0, n = this.effects.length; r < n; r++)
        this.effects[r].stop();
      for (r = 0, n = this.cleanups.length; r < n; r++)
        this.cleanups[r]();
      if (this.scopes)
        for (r = 0, n = this.scopes.length; r < n; r++)
          this.scopes[r].stop(!0);
      if (!this.detached && this.parent && !t) {
        const o = this.parent.scopes.pop();
        o && o !== this && (this.parent.scopes[this.index] = o, o.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function eu(e, t = Ie) {
  t && t.active && t.effects.push(e);
}
function tu() {
  return Ie;
}
const Er = (e) => {
  const t = new Set(e);
  return t.w = 0, t.n = 0, t;
}, sa = (e) => (e.w & ct) > 0, aa = (e) => (e.n & ct) > 0, ru = ({ deps: e }) => {
  if (e.length)
    for (let t = 0; t < e.length; t++)
      e[t].w |= ct;
}, nu = (e) => {
  const { deps: t } = e;
  if (t.length) {
    let r = 0;
    for (let n = 0; n < t.length; n++) {
      const o = t[n];
      sa(o) && !aa(o) ? o.delete(e) : t[r++] = o, o.w &= ~ct, o.n &= ~ct;
    }
    t.length = r;
  }
}, Ao = /* @__PURE__ */ new WeakMap();
let ur = 0, ct = 1;
const No = 30;
let Ee;
const Nt = Symbol(process.env.NODE_ENV !== "production" ? "iterate" : ""), Oo = Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class $o {
  constructor(t, r = null, n) {
    this.fn = t, this.scheduler = r, this.active = !0, this.deps = [], this.parent = void 0, eu(this, n);
  }
  run() {
    if (!this.active)
      return this.fn();
    let t = Ee, r = lt;
    for (; t; ) {
      if (t === this)
        return;
      t = t.parent;
    }
    try {
      return this.parent = Ee, Ee = this, lt = !0, ct = 1 << ++ur, ur <= No ? ru(this) : Ri(this), this.fn();
    } finally {
      ur <= No && nu(this), ct = 1 << --ur, Ee = this.parent, lt = r, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    Ee === this ? this.deferStop = !0 : this.active && (Ri(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function Ri(e) {
  const { deps: t } = e;
  if (t.length) {
    for (let r = 0; r < t.length; r++)
      t[r].delete(e);
    t.length = 0;
  }
}
let lt = !0;
const la = [];
function _t() {
  la.push(lt), lt = !1;
}
function Tt() {
  const e = la.pop();
  lt = e === void 0 ? !0 : e;
}
function pe(e, t, r) {
  if (lt && Ee) {
    let n = Ao.get(e);
    n || Ao.set(e, n = /* @__PURE__ */ new Map());
    let o = n.get(r);
    o || n.set(r, o = Er());
    const i = process.env.NODE_ENV !== "production" ? { effect: Ee, target: e, type: t, key: r } : void 0;
    wo(o, i);
  }
}
function wo(e, t) {
  let r = !1;
  ur <= No ? aa(e) || (e.n |= ct, r = !sa(e)) : r = !e.has(Ee), r && (e.add(Ee), Ee.deps.push(e), process.env.NODE_ENV !== "production" && Ee.onTrack && Ee.onTrack(
    $(
      {
        effect: Ee
      },
      t
    )
  ));
}
function He(e, t, r, n, o, i) {
  const s = Ao.get(e);
  if (!s)
    return;
  let a = [];
  if (t === "clear")
    a = [...s.values()];
  else if (r === "length" && R(e)) {
    const u = Number(n);
    s.forEach((p, f) => {
      (f === "length" || f >= u) && a.push(p);
    });
  } else
    switch (r !== void 0 && a.push(s.get(r)), t) {
      case "add":
        R(e) ? Zo(r) && a.push(s.get("length")) : (a.push(s.get(Nt)), At(e) && a.push(s.get(Oo)));
        break;
      case "delete":
        R(e) || (a.push(s.get(Nt)), At(e) && a.push(s.get(Oo)));
        break;
      case "set":
        At(e) && a.push(s.get(Nt));
        break;
    }
  const l = process.env.NODE_ENV !== "production" ? { target: e, type: t, key: r, newValue: n, oldValue: o, oldTarget: i } : void 0;
  if (a.length === 1)
    a[0] && (process.env.NODE_ENV !== "production" ? qt(a[0], l) : qt(a[0]));
  else {
    const u = [];
    for (const p of a)
      p && u.push(...p);
    process.env.NODE_ENV !== "production" ? qt(Er(u), l) : qt(Er(u));
  }
}
function qt(e, t) {
  const r = R(e) ? e : [...e];
  for (const n of r)
    n.computed && ji(n, t);
  for (const n of r)
    n.computed || ji(n, t);
}
function ji(e, t) {
  (e !== Ee || e.allowRecurse) && (process.env.NODE_ENV !== "production" && e.onTrigger && e.onTrigger($({ effect: e }, t)), e.scheduler ? e.scheduler() : e.run());
}
const ou = /* @__PURE__ */ dt("__proto__,__v_isRef,__isVue"), ua = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(Qo)
), iu = /* @__PURE__ */ yn(), su = /* @__PURE__ */ yn(!1, !0), au = /* @__PURE__ */ yn(!0), lu = /* @__PURE__ */ yn(!0, !0), Vi = /* @__PURE__ */ uu();
function uu() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...r) {
      const n = B(this);
      for (let i = 0, s = this.length; i < s; i++)
        pe(n, "get", i + "");
      const o = n[t](...r);
      return o === -1 || o === !1 ? n[t](...r.map(B)) : o;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...r) {
      _t();
      const n = B(this)[t].apply(this, r);
      return Tt(), n;
    };
  }), e;
}
function cu(e) {
  const t = B(this);
  return pe(t, "has", e), t.hasOwnProperty(e);
}
function yn(e = !1, t = !1) {
  return function(n, o, i) {
    if (o === "__v_isReactive")
      return !e;
    if (o === "__v_isReadonly")
      return e;
    if (o === "__v_isShallow")
      return t;
    if (o === "__v_raw" && i === (e ? t ? ya : ga : t ? ma : ha).get(n))
      return n;
    const s = R(n);
    if (!e) {
      if (s && k(Vi, o))
        return Reflect.get(Vi, o, i);
      if (o === "hasOwnProperty")
        return cu;
    }
    const a = Reflect.get(n, o, i);
    return (Qo(o) ? ua.has(o) : ou(o)) || (e || pe(n, "get", o), t) ? a : se(a) ? s && Zo(o) ? a : a.value : Z(a) ? e ? va(a) : ei(a) : a;
  };
}
const fu = /* @__PURE__ */ ca(), pu = /* @__PURE__ */ ca(!0);
function ca(e = !1) {
  return function(r, n, o, i) {
    let s = r[n];
    if (ft(s) && se(s) && !se(o))
      return !1;
    if (!e && (!tn(o) && !ft(o) && (s = B(s), o = B(o)), !R(r) && se(s) && !se(o)))
      return s.value = o, !0;
    const a = R(r) && Zo(n) ? Number(n) < r.length : k(r, n), l = Reflect.set(r, n, o, i);
    return r === B(i) && (a ? vr(o, s) && He(r, "set", n, o, s) : He(r, "add", n, o)), l;
  };
}
function du(e, t) {
  const r = k(e, t), n = e[t], o = Reflect.deleteProperty(e, t);
  return o && r && He(e, "delete", t, void 0, n), o;
}
function hu(e, t) {
  const r = Reflect.has(e, t);
  return (!Qo(t) || !ua.has(t)) && pe(e, "has", t), r;
}
function mu(e) {
  return pe(e, "iterate", R(e) ? "length" : Nt), Reflect.ownKeys(e);
}
const fa = {
  get: iu,
  set: fu,
  deleteProperty: du,
  has: hu,
  ownKeys: mu
}, pa = {
  get: au,
  set(e, t) {
    return process.env.NODE_ENV !== "production" && bo(
      `Set operation on key "${String(t)}" failed: target is readonly.`,
      e
    ), !0;
  },
  deleteProperty(e, t) {
    return process.env.NODE_ENV !== "production" && bo(
      `Delete operation on key "${String(t)}" failed: target is readonly.`,
      e
    ), !0;
  }
}, gu = /* @__PURE__ */ $(
  {},
  fa,
  {
    get: su,
    set: pu
  }
), yu = /* @__PURE__ */ $(
  {},
  pa,
  {
    get: lu
  }
), Go = (e) => e, vn = (e) => Reflect.getPrototypeOf(e);
function _r(e, t, r = !1, n = !1) {
  e = e.__v_raw;
  const o = B(e), i = B(t);
  r || (t !== i && pe(o, "get", t), pe(o, "get", i));
  const { has: s } = vn(o), a = n ? Go : r ? ti : br;
  if (s.call(o, t))
    return a(e.get(t));
  if (s.call(o, i))
    return a(e.get(i));
  e !== o && e.get(t);
}
function Tr(e, t = !1) {
  const r = this.__v_raw, n = B(r), o = B(e);
  return t || (e !== o && pe(n, "has", e), pe(n, "has", o)), e === o ? r.has(e) : r.has(e) || r.has(o);
}
function Pr(e, t = !1) {
  return e = e.__v_raw, !t && pe(B(e), "iterate", Nt), Reflect.get(e, "size", e);
}
function Fi(e) {
  e = B(e);
  const t = B(this);
  return vn(t).has.call(t, e) || (t.add(e), He(t, "add", e, e)), this;
}
function Bi(e, t) {
  t = B(t);
  const r = B(this), { has: n, get: o } = vn(r);
  let i = n.call(r, e);
  i ? process.env.NODE_ENV !== "production" && da(r, n, e) : (e = B(e), i = n.call(r, e));
  const s = o.call(r, e);
  return r.set(e, t), i ? vr(t, s) && He(r, "set", e, t, s) : He(r, "add", e, t), this;
}
function Li(e) {
  const t = B(this), { has: r, get: n } = vn(t);
  let o = r.call(t, e);
  o ? process.env.NODE_ENV !== "production" && da(t, r, e) : (e = B(e), o = r.call(t, e));
  const i = n ? n.call(t, e) : void 0, s = t.delete(e);
  return o && He(t, "delete", e, void 0, i), s;
}
function ki() {
  const e = B(this), t = e.size !== 0, r = process.env.NODE_ENV !== "production" ? At(e) ? new Map(e) : new Set(e) : void 0, n = e.clear();
  return t && He(e, "clear", void 0, void 0, r), n;
}
function Rr(e, t) {
  return function(n, o) {
    const i = this, s = i.__v_raw, a = B(s), l = t ? Go : e ? ti : br;
    return !e && pe(a, "iterate", Nt), s.forEach((u, p) => n.call(o, l(u), l(p), i));
  };
}
function jr(e, t, r) {
  return function(...n) {
    const o = this.__v_raw, i = B(o), s = At(i), a = e === "entries" || e === Symbol.iterator && s, l = e === "keys" && s, u = o[e](...n), p = r ? Go : t ? ti : br;
    return !t && pe(
      i,
      "iterate",
      l ? Oo : Nt
    ), {
      next() {
        const { value: f, done: h } = u.next();
        return h ? { value: f, done: h } : {
          value: a ? [p(f[0]), p(f[1])] : p(f),
          done: h
        };
      },
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function tt(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const r = t[0] ? `on key "${t[0]}" ` : "";
      console.warn(
        `${mn(e)} operation ${r}failed: target is readonly.`,
        B(this)
      );
    }
    return e === "delete" ? !1 : this;
  };
}
function vu() {
  const e = {
    get(i) {
      return _r(this, i);
    },
    get size() {
      return Pr(this);
    },
    has: Tr,
    add: Fi,
    set: Bi,
    delete: Li,
    clear: ki,
    forEach: Rr(!1, !1)
  }, t = {
    get(i) {
      return _r(this, i, !1, !0);
    },
    get size() {
      return Pr(this);
    },
    has: Tr,
    add: Fi,
    set: Bi,
    delete: Li,
    clear: ki,
    forEach: Rr(!1, !0)
  }, r = {
    get(i) {
      return _r(this, i, !0);
    },
    get size() {
      return Pr(this, !0);
    },
    has(i) {
      return Tr.call(this, i, !0);
    },
    add: tt("add"),
    set: tt("set"),
    delete: tt("delete"),
    clear: tt("clear"),
    forEach: Rr(!0, !1)
  }, n = {
    get(i) {
      return _r(this, i, !0, !0);
    },
    get size() {
      return Pr(this, !0);
    },
    has(i) {
      return Tr.call(this, i, !0);
    },
    add: tt("add"),
    set: tt("set"),
    delete: tt("delete"),
    clear: tt("clear"),
    forEach: Rr(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((i) => {
    e[i] = jr(
      i,
      !1,
      !1
    ), r[i] = jr(
      i,
      !0,
      !1
    ), t[i] = jr(
      i,
      !1,
      !0
    ), n[i] = jr(
      i,
      !0,
      !0
    );
  }), [
    e,
    r,
    t,
    n
  ];
}
const [
  Eu,
  bu,
  Au,
  Nu
] = /* @__PURE__ */ vu();
function En(e, t) {
  const r = t ? e ? Nu : Au : e ? bu : Eu;
  return (n, o, i) => o === "__v_isReactive" ? !e : o === "__v_isReadonly" ? e : o === "__v_raw" ? n : Reflect.get(
    k(r, o) && o in n ? r : n,
    o,
    i
  );
}
const Ou = {
  get: /* @__PURE__ */ En(!1, !1)
}, wu = {
  get: /* @__PURE__ */ En(!1, !0)
}, Cu = {
  get: /* @__PURE__ */ En(!0, !1)
}, Du = {
  get: /* @__PURE__ */ En(!0, !0)
};
function da(e, t, r) {
  const n = B(r);
  if (n !== r && t.call(e, n)) {
    const o = Xo(e);
    console.warn(
      `Reactive ${o} contains both the raw and reactive versions of the same object${o === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const ha = /* @__PURE__ */ new WeakMap(), ma = /* @__PURE__ */ new WeakMap(), ga = /* @__PURE__ */ new WeakMap(), ya = /* @__PURE__ */ new WeakMap();
function Mu(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Iu(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Mu(Xo(e));
}
function ei(e) {
  return ft(e) ? e : bn(
    e,
    !1,
    fa,
    Ou,
    ha
  );
}
function xu(e) {
  return bn(
    e,
    !1,
    gu,
    wu,
    ma
  );
}
function va(e) {
  return bn(
    e,
    !0,
    pa,
    Cu,
    ga
  );
}
function cr(e) {
  return bn(
    e,
    !0,
    yu,
    Du,
    ya
  );
}
function bn(e, t, r, n, o) {
  if (!Z(e))
    return process.env.NODE_ENV !== "production" && console.warn(`value cannot be made reactive: ${String(e)}`), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = o.get(e);
  if (i)
    return i;
  const s = Iu(e);
  if (s === 0)
    return e;
  const a = new Proxy(
    e,
    s === 2 ? n : r
  );
  return o.set(e, a), a;
}
function Ot(e) {
  return ft(e) ? Ot(e.__v_raw) : !!(e && e.__v_isReactive);
}
function ft(e) {
  return !!(e && e.__v_isReadonly);
}
function tn(e) {
  return !!(e && e.__v_isShallow);
}
function Co(e) {
  return Ot(e) || ft(e);
}
function B(e) {
  const t = e && e.__v_raw;
  return t ? B(t) : e;
}
function Ea(e) {
  return Gr(e, "__v_skip", !0), e;
}
const br = (e) => Z(e) ? ei(e) : e, ti = (e) => Z(e) ? va(e) : e;
function ba(e) {
  lt && Ee && (e = B(e), process.env.NODE_ENV !== "production" ? wo(e.dep || (e.dep = Er()), {
    target: e,
    type: "get",
    key: "value"
  }) : wo(e.dep || (e.dep = Er())));
}
function Aa(e, t) {
  e = B(e);
  const r = e.dep;
  r && (process.env.NODE_ENV !== "production" ? qt(r, {
    target: e,
    type: "set",
    key: "value",
    newValue: t
  }) : qt(r));
}
function se(e) {
  return !!(e && e.__v_isRef === !0);
}
function ir(e) {
  return Su(e, !1);
}
function Su(e, t) {
  return se(e) ? e : new _u(e, t);
}
class _u {
  constructor(t, r) {
    this.__v_isShallow = r, this.dep = void 0, this.__v_isRef = !0, this._rawValue = r ? t : B(t), this._value = r ? t : br(t);
  }
  get value() {
    return ba(this), this._value;
  }
  set value(t) {
    const r = this.__v_isShallow || tn(t) || ft(t);
    t = r ? t : B(t), vr(t, this._rawValue) && (this._rawValue = t, this._value = r ? t : br(t), Aa(this, t));
  }
}
function Tu(e) {
  return se(e) ? e.value : e;
}
const Pu = {
  get: (e, t, r) => Tu(Reflect.get(e, t, r)),
  set: (e, t, r, n) => {
    const o = e[t];
    return se(o) && !se(r) ? (o.value = r, !0) : Reflect.set(e, t, r, n);
  }
};
function Na(e) {
  return Ot(e) ? e : new Proxy(e, Pu);
}
class Ru {
  constructor(t, r, n, o) {
    this._setter = r, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this._dirty = !0, this.effect = new $o(t, () => {
      this._dirty || (this._dirty = !0, Aa(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !o, this.__v_isReadonly = n;
  }
  get value() {
    const t = B(this);
    return ba(t), (t._dirty || !t._cacheable) && (t._dirty = !1, t._value = t.effect.run()), t._value;
  }
  set value(t) {
    this._setter(t);
  }
}
function ju(e, t, r = !1) {
  let n, o;
  const i = V(e);
  i ? (n = e, o = process.env.NODE_ENV !== "production" ? () => {
    console.warn("Write operation failed: computed value is readonly");
  } : ce) : (n = e.get, o = e.set);
  const s = new Ru(n, o, i || !o, r);
  return process.env.NODE_ENV !== "production" && t && !r && (s.effect.onTrack = t.onTrack, s.effect.onTrigger = t.onTrigger), s;
}
const wt = [];
function Ur(e) {
  wt.push(e);
}
function Hr() {
  wt.pop();
}
function O(e, ...t) {
  if (process.env.NODE_ENV === "production")
    return;
  _t();
  const r = wt.length ? wt[wt.length - 1].component : null, n = r && r.appContext.config.warnHandler, o = Vu();
  if (n)
    Ze(
      n,
      r,
      11,
      [
        e + t.join(""),
        r && r.proxy,
        o.map(
          ({ vnode: i }) => `at <${Mn(r, i.type)}>`
        ).join(`
`),
        o
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    o.length && i.push(`
`, ...Fu(o)), console.warn(...i);
  }
  Tt();
}
function Vu() {
  let e = wt[wt.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const r = t[0];
    r && r.vnode === e ? r.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const n = e.component && e.component.parent;
    e = n && n.vnode;
  }
  return t;
}
function Fu(e) {
  const t = [];
  return e.forEach((r, n) => {
    t.push(...n === 0 ? [] : [`
`], ...Bu(r));
  }), t;
}
function Bu({ vnode: e, recurseCount: t }) {
  const r = t > 0 ? `... (${t} recursive calls)` : "", n = e.component ? e.component.parent == null : !1, o = ` at <${Mn(
    e.component,
    e.type,
    n
  )}`, i = ">" + r;
  return e.props ? [o, ...Lu(e.props), i] : [o + i];
}
function Lu(e) {
  const t = [], r = Object.keys(e);
  return r.slice(0, 3).forEach((n) => {
    t.push(...Oa(n, e[n]));
  }), r.length > 3 && t.push(" ..."), t;
}
function Oa(e, t, r) {
  return ne(t) ? (t = JSON.stringify(t), r ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? r ? t : [`${e}=${t}`] : se(t) ? (t = Oa(e, B(t.value), !0), r ? t : [`${e}=Ref<`, t, ">"]) : V(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = B(t), r ? t : [`${e}=`, t]);
}
const ri = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  [0]: "setup function",
  [1]: "render function",
  [2]: "watcher getter",
  [3]: "watcher callback",
  [4]: "watcher cleanup function",
  [5]: "native event handler",
  [6]: "component event handler",
  [7]: "vnode hook",
  [8]: "directive hook",
  [9]: "transition hook",
  [10]: "app errorHandler",
  [11]: "app warnHandler",
  [12]: "ref function",
  [13]: "async component loader",
  [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function Ze(e, t, r, n) {
  let o;
  try {
    o = n ? e(...n) : e();
  } catch (i) {
    An(i, t, r);
  }
  return o;
}
function Te(e, t, r, n) {
  if (V(e)) {
    const i = Ze(e, t, r, n);
    return i && Jo(i) && i.catch((s) => {
      An(s, t, r);
    }), i;
  }
  const o = [];
  for (let i = 0; i < e.length; i++)
    o.push(Te(e[i], t, r, n));
  return o;
}
function An(e, t, r, n = !0) {
  const o = t ? t.vnode : null;
  if (t) {
    let i = t.parent;
    const s = t.proxy, a = process.env.NODE_ENV !== "production" ? ri[r] : r;
    for (; i; ) {
      const u = i.ec;
      if (u) {
        for (let p = 0; p < u.length; p++)
          if (u[p](e, s, a) === !1)
            return;
      }
      i = i.parent;
    }
    const l = t.appContext.config.errorHandler;
    if (l) {
      Ze(
        l,
        null,
        10,
        [e, s, a]
      );
      return;
    }
  }
  ku(e, r, o, n);
}
function ku(e, t, r, n = !0) {
  if (process.env.NODE_ENV !== "production") {
    const o = ri[t];
    if (r && Ur(r), O(`Unhandled error${o ? ` during execution of ${o}` : ""}`), r && Hr(), n)
      throw e;
    console.error(e);
  } else
    console.error(e);
}
let Ar = !1, Do = !1;
const me = [];
let ze = 0;
const Yt = [];
let Be = null, nt = 0;
const wa = /* @__PURE__ */ Promise.resolve();
let ni = null;
const zu = 100;
function Uu(e) {
  const t = ni || wa;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Hu(e) {
  let t = ze + 1, r = me.length;
  for (; t < r; ) {
    const n = t + r >>> 1;
    Nr(me[n]) < e ? t = n + 1 : r = n;
  }
  return t;
}
function Nn(e) {
  (!me.length || !me.includes(
    e,
    Ar && e.allowRecurse ? ze + 1 : ze
  )) && (e.id == null ? me.push(e) : me.splice(Hu(e.id), 0, e), Ca());
}
function Ca() {
  !Ar && !Do && (Do = !0, ni = wa.then(Ia));
}
function qu(e) {
  const t = me.indexOf(e);
  t > ze && me.splice(t, 1);
}
function Da(e) {
  R(e) ? Yt.push(...e) : (!Be || !Be.includes(
    e,
    e.allowRecurse ? nt + 1 : nt
  )) && Yt.push(e), Ca();
}
function zi(e, t = Ar ? ze + 1 : 0) {
  for (process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()); t < me.length; t++) {
    const r = me[t];
    if (r && r.pre) {
      if (process.env.NODE_ENV !== "production" && oi(e, r))
        continue;
      me.splice(t, 1), t--, r();
    }
  }
}
function Ma(e) {
  if (Yt.length) {
    const t = [...new Set(Yt)];
    if (Yt.length = 0, Be) {
      Be.push(...t);
      return;
    }
    for (Be = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Be.sort((r, n) => Nr(r) - Nr(n)), nt = 0; nt < Be.length; nt++)
      process.env.NODE_ENV !== "production" && oi(e, Be[nt]) || Be[nt]();
    Be = null, nt = 0;
  }
}
const Nr = (e) => e.id == null ? 1 / 0 : e.id, Wu = (e, t) => {
  const r = Nr(e) - Nr(t);
  if (r === 0) {
    if (e.pre && !t.pre)
      return -1;
    if (t.pre && !e.pre)
      return 1;
  }
  return r;
};
function Ia(e) {
  Do = !1, Ar = !0, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), me.sort(Wu);
  const t = process.env.NODE_ENV !== "production" ? (r) => oi(e, r) : ce;
  try {
    for (ze = 0; ze < me.length; ze++) {
      const r = me[ze];
      if (r && r.active !== !1) {
        if (process.env.NODE_ENV !== "production" && t(r))
          continue;
        Ze(r, null, 14);
      }
    }
  } finally {
    ze = 0, me.length = 0, Ma(e), Ar = !1, ni = null, (me.length || Yt.length) && Ia(e);
  }
}
function oi(e, t) {
  if (!e.has(t))
    e.set(t, 1);
  else {
    const r = e.get(t);
    if (r > zu) {
      const n = t.ownerInstance, o = n && rl(n.type);
      return O(
        `Maximum recursive updates exceeded${o ? ` in component <${o}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`
      ), !0;
    } else
      e.set(t, r + 1);
  }
}
let Ct = !1;
const Ut = /* @__PURE__ */ new Set();
process.env.NODE_ENV !== "production" && (en().__VUE_HMR_RUNTIME__ = {
  createRecord: Fn(xa),
  rerender: Fn(Qu),
  reload: Fn(Ju)
});
const St = /* @__PURE__ */ new Map();
function Ku(e) {
  const t = e.type.__hmrId;
  let r = St.get(t);
  r || (xa(t, e.type), r = St.get(t)), r.instances.add(e);
}
function Yu(e) {
  St.get(e.type.__hmrId).instances.delete(e);
}
function xa(e, t) {
  return St.has(e) ? !1 : (St.set(e, {
    initialDef: dr(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function dr(e) {
  return nl(e) ? e.__vccOpts : e;
}
function Qu(e, t) {
  const r = St.get(e);
  !r || (r.initialDef.render = t, [...r.instances].forEach((n) => {
    t && (n.render = t, dr(n.type).render = t), n.renderCache = [], Ct = !0, n.update(), Ct = !1;
  }));
}
function Ju(e, t) {
  const r = St.get(e);
  if (!r)
    return;
  t = dr(t), Ui(r.initialDef, t);
  const n = [...r.instances];
  for (const o of n) {
    const i = dr(o.type);
    Ut.has(i) || (i !== r.initialDef && Ui(i, t), Ut.add(i)), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? (Ut.add(i), o.ceReload(t.styles), Ut.delete(i)) : o.parent ? Nn(o.parent.update) : o.appContext.reload ? o.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    );
  }
  Da(() => {
    for (const o of n)
      Ut.delete(
        dr(o.type)
      );
  });
}
function Ui(e, t) {
  $(e, t);
  for (const r in e)
    r !== "__file" && !(r in t) && delete e[r];
}
function Fn(e) {
  return (t, r) => {
    try {
      return e(t, r);
    } catch (n) {
      console.error(n), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Ue, fr = [], Mo = !1;
function Dr(e, ...t) {
  Ue ? Ue.emit(e, ...t) : Mo || fr.push({ event: e, args: t });
}
function Sa(e, t) {
  var r, n;
  Ue = e, Ue ? (Ue.enabled = !0, fr.forEach(({ event: o, args: i }) => Ue.emit(o, ...i)), fr = []) : typeof window < "u" && window.HTMLElement && !((n = (r = window.navigator) == null ? void 0 : r.userAgent) != null && n.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    Sa(i, t);
  }), setTimeout(() => {
    Ue || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Mo = !0, fr = []);
  }, 3e3)) : (Mo = !0, fr = []);
}
function Xu(e, t) {
  Dr("app:init", e, t, {
    Fragment: Le,
    Text: Mr,
    Comment: we,
    Static: Yr
  });
}
function Zu(e) {
  Dr("app:unmount", e);
}
const $u = /* @__PURE__ */ ii(
  "component:added"
), _a = /* @__PURE__ */ ii("component:updated"), Gu = /* @__PURE__ */ ii(
  "component:removed"
), ec = (e) => {
  Ue && typeof Ue.cleanupBuffer == "function" && !Ue.cleanupBuffer(e) && Gu(e);
};
function ii(e) {
  return (t) => {
    Dr(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const tc = /* @__PURE__ */ Ta(
  "perf:start"
), rc = /* @__PURE__ */ Ta(
  "perf:end"
);
function Ta(e) {
  return (t, r, n) => {
    Dr(e, t.appContext.app, t.uid, t, r, n);
  };
}
function nc(e, t, r) {
  Dr(
    "component:emit",
    e.appContext.app,
    e,
    t,
    r
  );
}
function oc(e, t, ...r) {
  if (e.isUnmounted)
    return;
  const n = e.vnode.props || X;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: p,
      propsOptions: [f]
    } = e;
    if (p)
      if (!(t in p))
        (!f || !(vt(t) in f)) && O(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${vt(t)}" prop.`
        );
      else {
        const h = p[t];
        V(h) && (h(...r) || O(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let o = r;
  const i = t.startsWith("update:"), s = i && t.slice(7);
  if (s && s in n) {
    const p = `${s === "modelValue" ? "model" : s}Modifiers`, { number: f, trim: h } = n[p] || X;
    h && (o = r.map((E) => ne(E) ? E.trim() : E)), f && (o = r.map(Ul));
  }
  if (process.env.NODE_ENV !== "production" && nc(e, t, o), process.env.NODE_ENV !== "production") {
    const p = t.toLowerCase();
    p !== t && n[vt(p)] && O(
      `Event "${p}" is emitted in component ${Mn(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${ut(t)}" instead of "${t}".`
    );
  }
  let a, l = n[a = vt(t)] || n[a = vt(Xt(t))];
  !l && i && (l = n[a = vt(ut(t))]), l && Te(
    l,
    e,
    6,
    o
  );
  const u = n[a + "Once"];
  if (u) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Te(
      u,
      e,
      6,
      o
    );
  }
}
function Pa(e, t, r = !1) {
  const n = t.emitsCache, o = n.get(e);
  if (o !== void 0)
    return o;
  const i = e.emits;
  let s = {}, a = !1;
  if (!V(e)) {
    const l = (u) => {
      const p = Pa(u, t, !0);
      p && (a = !0, $(s, p));
    };
    !r && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !i && !a ? (Z(e) && n.set(e, null), null) : (R(i) ? i.forEach((l) => s[l] = null) : $(s, i), Z(e) && n.set(e, s), s);
}
function On(e, t) {
  return !e || !Cr(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), k(e, t[0].toLowerCase() + t.slice(1)) || k(e, ut(t)) || k(e, t));
}
let De = null, wn = null;
function rn(e) {
  const t = De;
  return De = e, wn = e && e.type.__scopeId || null, t;
}
function ic(e) {
  wn = e;
}
function sc() {
  wn = null;
}
function ac(e, t = De, r) {
  if (!t || e._n)
    return e;
  const n = (...o) => {
    n._d && es(-1);
    const i = rn(t);
    let s;
    try {
      s = e(...o);
    } finally {
      rn(i), n._d && es(1);
    }
    return process.env.NODE_ENV !== "production" && _a(t), s;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
let Io = !1;
function nn() {
  Io = !0;
}
function Bn(e) {
  const {
    type: t,
    vnode: r,
    proxy: n,
    withProxy: o,
    props: i,
    propsOptions: [s],
    slots: a,
    attrs: l,
    emit: u,
    render: p,
    renderCache: f,
    data: h,
    setupState: E,
    ctx: D,
    inheritAttrs: I
  } = e;
  let L, x;
  const K = rn(e);
  process.env.NODE_ENV !== "production" && (Io = !1);
  try {
    if (r.shapeFlag & 4) {
      const _ = o || n;
      L = Se(
        p.call(
          _,
          _,
          f,
          i,
          E,
          h,
          D
        )
      ), x = l;
    } else {
      const _ = t;
      process.env.NODE_ENV !== "production" && l === i && nn(), L = Se(
        _.length > 1 ? _(
          i,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return nn(), l;
            },
            slots: a,
            emit: u
          } : { attrs: l, slots: a, emit: u }
        ) : _(
          i,
          null
        )
      ), x = t.props ? l : uc(l);
    }
  } catch (_) {
    hr.length = 0, An(_, e, 1), L = $e(we);
  }
  let j = L, N;
  if (process.env.NODE_ENV !== "production" && L.patchFlag > 0 && L.patchFlag & 2048 && ([j, N] = lc(L)), x && I !== !1) {
    const _ = Object.keys(x), { shapeFlag: ae } = j;
    if (_.length) {
      if (ae & 7)
        s && _.some($r) && (x = cc(
          x,
          s
        )), j = pt(j, x);
      else if (process.env.NODE_ENV !== "production" && !Io && j.type !== we) {
        const G = Object.keys(l), oe = [], ee = [];
        for (let Y = 0, te = G.length; Y < te; Y++) {
          const W = G[Y];
          Cr(W) ? $r(W) || oe.push(W[2].toLowerCase() + W.slice(3)) : ee.push(W);
        }
        ee.length && O(
          `Extraneous non-props attributes (${ee.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), oe.length && O(
          `Extraneous non-emits event listeners (${oe.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return r.dirs && (process.env.NODE_ENV !== "production" && !Hi(j) && O(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), j = pt(j), j.dirs = j.dirs ? j.dirs.concat(r.dirs) : r.dirs), r.transition && (process.env.NODE_ENV !== "production" && !Hi(j) && O(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), j.transition = r.transition), process.env.NODE_ENV !== "production" && N ? N(j) : L = j, rn(K), L;
}
const lc = (e) => {
  const t = e.children, r = e.dynamicChildren, n = Ra(t);
  if (!n)
    return [e, void 0];
  const o = t.indexOf(n), i = r ? r.indexOf(n) : -1, s = (a) => {
    t[o] = a, r && (i > -1 ? r[i] = a : a.patchFlag > 0 && (e.dynamicChildren = [...r, a]));
  };
  return [Se(n), s];
};
function Ra(e) {
  let t;
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (ci(n)) {
      if (n.type !== we || n.children === "v-if") {
        if (t)
          return;
        t = n;
      }
    } else
      return;
  }
  return t;
}
const uc = (e) => {
  let t;
  for (const r in e)
    (r === "class" || r === "style" || Cr(r)) && ((t || (t = {}))[r] = e[r]);
  return t;
}, cc = (e, t) => {
  const r = {};
  for (const n in e)
    (!$r(n) || !(n.slice(9) in t)) && (r[n] = e[n]);
  return r;
}, Hi = (e) => e.shapeFlag & 7 || e.type === we;
function fc(e, t, r) {
  const { props: n, children: o, component: i } = e, { props: s, children: a, patchFlag: l } = t, u = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (o || a) && Ct || t.dirs || t.transition)
    return !0;
  if (r && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return n ? qi(n, s, u) : !!s;
    if (l & 8) {
      const p = t.dynamicProps;
      for (let f = 0; f < p.length; f++) {
        const h = p[f];
        if (s[h] !== n[h] && !On(u, h))
          return !0;
      }
    }
  } else
    return (o || a) && (!a || !a.$stable) ? !0 : n === s ? !1 : n ? s ? qi(n, s, u) : !0 : !!s;
  return !1;
}
function qi(e, t, r) {
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !0;
  for (let o = 0; o < n.length; o++) {
    const i = n[o];
    if (t[i] !== e[i] && !On(r, i))
      return !0;
  }
  return !1;
}
function pc({ vnode: e, parent: t }, r) {
  for (; t && t.subTree === e; )
    (e = t.vnode).el = r, t = t.parent;
}
const dc = (e) => e.__isSuspense;
function hc(e, t) {
  t && t.pendingBranch ? R(e) ? t.effects.push(...e) : t.effects.push(e) : Da(e);
}
const Vr = {};
function Ln(e, t, r) {
  return process.env.NODE_ENV !== "production" && !V(t) && O(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), ja(e, t, r);
}
function ja(e, t, { immediate: r, deep: n, flush: o, onTrack: i, onTrigger: s } = X) {
  var a;
  process.env.NODE_ENV !== "production" && !t && (r !== void 0 && O(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), n !== void 0 && O(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const l = (_) => {
    O(
      "Invalid watch source: ",
      _,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, u = tu() === ((a = fe) == null ? void 0 : a.scope) ? fe : null;
  let p, f = !1, h = !1;
  if (se(e) ? (p = () => e.value, f = tn(e)) : Ot(e) ? (p = () => e, n = !0) : R(e) ? (h = !0, f = e.some((_) => Ot(_) || tn(_)), p = () => e.map((_) => {
    if (se(_))
      return _.value;
    if (Ot(_))
      return Wt(_);
    if (V(_))
      return Ze(_, u, 2);
    process.env.NODE_ENV !== "production" && l(_);
  })) : V(e) ? t ? p = () => Ze(e, u, 2) : p = () => {
    if (!(u && u.isUnmounted))
      return E && E(), Te(
        e,
        u,
        3,
        [D]
      );
  } : (p = ce, process.env.NODE_ENV !== "production" && l(e)), t && n) {
    const _ = p;
    p = () => Wt(_());
  }
  let E, D = (_) => {
    E = j.onStop = () => {
      Ze(_, u, 4);
    };
  }, I;
  if (wr)
    if (D = ce, t ? r && Te(t, u, 3, [
      p(),
      h ? [] : void 0,
      D
    ]) : p(), o === "sync") {
      const _ = Af();
      I = _.__watcherHandles || (_.__watcherHandles = []);
    } else
      return ce;
  let L = h ? new Array(e.length).fill(Vr) : Vr;
  const x = () => {
    if (!!j.active)
      if (t) {
        const _ = j.run();
        (n || f || (h ? _.some(
          (ae, G) => vr(ae, L[G])
        ) : vr(_, L))) && (E && E(), Te(t, u, 3, [
          _,
          L === Vr ? void 0 : h && L[0] === Vr ? [] : L,
          D
        ]), L = _);
      } else
        j.run();
  };
  x.allowRecurse = !!t;
  let K;
  o === "sync" ? K = x : o === "post" ? K = () => be(x, u && u.suspense) : (x.pre = !0, u && (x.id = u.uid), K = () => Nn(x));
  const j = new $o(p, K);
  process.env.NODE_ENV !== "production" && (j.onTrack = i, j.onTrigger = s), t ? r ? x() : L = j.run() : o === "post" ? be(
    j.run.bind(j),
    u && u.suspense
  ) : j.run();
  const N = () => {
    j.stop(), u && u.scope && Yo(u.scope.effects, j);
  };
  return I && I.push(N), N;
}
function mc(e, t, r) {
  const n = this.proxy, o = ne(e) ? e.includes(".") ? Va(n, e) : () => n[e] : e.bind(n, n);
  let i;
  V(t) ? i = t : (i = t.handler, r = t);
  const s = fe;
  Zt(this);
  const a = ja(o, i.bind(n), r);
  return s ? Zt(s) : Mt(), a;
}
function Va(e, t) {
  const r = t.split(".");
  return () => {
    let n = e;
    for (let o = 0; o < r.length && n; o++)
      n = n[r[o]];
    return n;
  };
}
function Wt(e, t) {
  if (!Z(e) || e.__v_skip || (t = t || /* @__PURE__ */ new Set(), t.has(e)))
    return e;
  if (t.add(e), se(e))
    Wt(e.value, t);
  else if (R(e))
    for (let r = 0; r < e.length; r++)
      Wt(e[r], t);
  else if (ta(e) || At(e))
    e.forEach((r) => {
      Wt(r, t);
    });
  else if (na(e))
    for (const r in e)
      Wt(e[r], t);
  return e;
}
function Fa(e) {
  Ll(e) && O("Do not use built-in directive ids as custom directive id: " + e);
}
function mt(e, t, r, n) {
  const o = e.dirs, i = t && t.dirs;
  for (let s = 0; s < o.length; s++) {
    const a = o[s];
    i && (a.oldValue = i[s].value);
    let l = a.dir[n];
    l && (_t(), Te(l, r, 8, [
      e.el,
      a,
      e,
      t
    ]), Tt());
  }
}
function gc(e, t) {
  return V(e) ? /* @__PURE__ */ (() => $({ name: e.name }, t, { setup: e }))() : e;
}
const qr = (e) => !!e.type.__asyncLoader, si = (e) => e.type.__isKeepAlive;
function yc(e, t) {
  Ba(e, "a", t);
}
function vc(e, t) {
  Ba(e, "da", t);
}
function Ba(e, t, r = fe) {
  const n = e.__wdc || (e.__wdc = () => {
    let o = r;
    for (; o; ) {
      if (o.isDeactivated)
        return;
      o = o.parent;
    }
    return e();
  });
  if (Cn(t, n, r), r) {
    let o = r.parent;
    for (; o && o.parent; )
      si(o.parent.vnode) && Ec(n, t, r, o), o = o.parent;
  }
}
function Ec(e, t, r, n) {
  const o = Cn(
    t,
    e,
    n,
    !0
  );
  ka(() => {
    Yo(n[t], o);
  }, r);
}
function Cn(e, t, r = fe, n = !1) {
  if (r) {
    const o = r[e] || (r[e] = []), i = t.__weh || (t.__weh = (...s) => {
      if (r.isUnmounted)
        return;
      _t(), Zt(r);
      const a = Te(t, r, e, s);
      return Mt(), Tt(), a;
    });
    return n ? o.unshift(i) : o.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const o = vt(ri[e].replace(/ hook$/, ""));
    O(
      `${o} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const Ge = (e) => (t, r = fe) => (!wr || e === "sp") && Cn(e, (...n) => t(...n), r), bc = Ge("bm"), La = Ge("m"), Ac = Ge("bu"), Nc = Ge("u"), Oc = Ge("bum"), ka = Ge("um"), wc = Ge("sp"), Cc = Ge(
  "rtg"
), Dc = Ge(
  "rtc"
);
function Mc(e, t = fe) {
  Cn("ec", e, t);
}
const Ic = Symbol.for("v-ndc"), xo = (e) => e ? el(e) ? di(e) || e.proxy : xo(e.parent) : null, Dt = /* @__PURE__ */ $(/* @__PURE__ */ Object.create(null), {
  $: (e) => e,
  $el: (e) => e.vnode.el,
  $data: (e) => e.data,
  $props: (e) => process.env.NODE_ENV !== "production" ? cr(e.props) : e.props,
  $attrs: (e) => process.env.NODE_ENV !== "production" ? cr(e.attrs) : e.attrs,
  $slots: (e) => process.env.NODE_ENV !== "production" ? cr(e.slots) : e.slots,
  $refs: (e) => process.env.NODE_ENV !== "production" ? cr(e.refs) : e.refs,
  $parent: (e) => xo(e.parent),
  $root: (e) => xo(e.root),
  $emit: (e) => e.emit,
  $options: (e) => li(e),
  $forceUpdate: (e) => e.f || (e.f = () => Nn(e.update)),
  $nextTick: (e) => e.n || (e.n = Uu.bind(e.proxy)),
  $watch: (e) => mc.bind(e)
}), ai = (e) => e === "_" || e === "$", kn = (e, t) => e !== X && !e.__isScriptSetup && k(e, t), za = {
  get({ _: e }, t) {
    const { ctx: r, setupState: n, data: o, props: i, accessCache: s, type: a, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let u;
    if (t[0] !== "$") {
      const E = s[t];
      if (E !== void 0)
        switch (E) {
          case 1:
            return n[t];
          case 2:
            return o[t];
          case 4:
            return r[t];
          case 3:
            return i[t];
        }
      else {
        if (kn(n, t))
          return s[t] = 1, n[t];
        if (o !== X && k(o, t))
          return s[t] = 2, o[t];
        if ((u = e.propsOptions[0]) && k(u, t))
          return s[t] = 3, i[t];
        if (r !== X && k(r, t))
          return s[t] = 4, r[t];
        So && (s[t] = 0);
      }
    }
    const p = Dt[t];
    let f, h;
    if (p)
      return t === "$attrs" ? (pe(e, "get", t), process.env.NODE_ENV !== "production" && nn()) : process.env.NODE_ENV !== "production" && t === "$slots" && pe(e, "get", t), p(e);
    if ((f = a.__cssModules) && (f = f[t]))
      return f;
    if (r !== X && k(r, t))
      return s[t] = 4, r[t];
    if (h = l.config.globalProperties, k(h, t))
      return h[t];
    process.env.NODE_ENV !== "production" && De && (!ne(t) || t.indexOf("__v") !== 0) && (o !== X && ai(t[0]) && k(o, t) ? O(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === De && O(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, r) {
    const { data: n, setupState: o, ctx: i } = e;
    return kn(o, t) ? (o[t] = r, !0) : process.env.NODE_ENV !== "production" && o.__isScriptSetup && k(o, t) ? (O(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : n !== X && k(n, t) ? (n[t] = r, !0) : k(e.props, t) ? (process.env.NODE_ENV !== "production" && O(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && O(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: r
    }) : i[t] = r, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: r, ctx: n, appContext: o, propsOptions: i }
  }, s) {
    let a;
    return !!r[s] || e !== X && k(e, s) || kn(t, s) || (a = i[0]) && k(a, s) || k(n, s) || k(Dt, s) || k(o.config.globalProperties, s);
  },
  defineProperty(e, t, r) {
    return r.get != null ? e._.accessCache[t] = 0 : k(r, "value") && this.set(e, t, r.value, null), Reflect.defineProperty(e, t, r);
  }
};
process.env.NODE_ENV !== "production" && (za.ownKeys = (e) => (O(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function xc(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(Dt).forEach((r) => {
    Object.defineProperty(t, r, {
      configurable: !0,
      enumerable: !1,
      get: () => Dt[r](e),
      set: ce
    });
  }), t;
}
function Sc(e) {
  const {
    ctx: t,
    propsOptions: [r]
  } = e;
  r && Object.keys(r).forEach((n) => {
    Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[n],
      set: ce
    });
  });
}
function _c(e) {
  const { ctx: t, setupState: r } = e;
  Object.keys(B(r)).forEach((n) => {
    if (!r.__isScriptSetup) {
      if (ai(n[0])) {
        O(
          `setup() return property ${JSON.stringify(
            n
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, n, {
        enumerable: !0,
        configurable: !0,
        get: () => r[n],
        set: ce
      });
    }
  });
}
function Wi(e) {
  return R(e) ? e.reduce(
    (t, r) => (t[r] = null, t),
    {}
  ) : e;
}
function Tc() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r) => {
    e[r] ? O(`${t} property "${r}" is already defined in ${e[r]}.`) : e[r] = t;
  };
}
let So = !0;
function Pc(e) {
  const t = li(e), r = e.proxy, n = e.ctx;
  So = !1, t.beforeCreate && Ki(t.beforeCreate, e, "bc");
  const {
    data: o,
    computed: i,
    methods: s,
    watch: a,
    provide: l,
    inject: u,
    created: p,
    beforeMount: f,
    mounted: h,
    beforeUpdate: E,
    updated: D,
    activated: I,
    deactivated: L,
    beforeDestroy: x,
    beforeUnmount: K,
    destroyed: j,
    unmounted: N,
    render: _,
    renderTracked: ae,
    renderTriggered: G,
    errorCaptured: oe,
    serverPrefetch: ee,
    expose: Y,
    inheritAttrs: te,
    components: W,
    directives: de,
    filters: Ae
  } = t, Ne = process.env.NODE_ENV !== "production" ? Tc() : null;
  if (process.env.NODE_ENV !== "production") {
    const [H] = e.propsOptions;
    if (H)
      for (const q in H)
        Ne("Props", q);
  }
  if (u && Rc(u, n, Ne), s)
    for (const H in s) {
      const q = s[H];
      V(q) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(n, H, {
        value: q.bind(r),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : n[H] = q.bind(r), process.env.NODE_ENV !== "production" && Ne("Methods", H)) : process.env.NODE_ENV !== "production" && O(
        `Method "${H}" has type "${typeof q}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (o) {
    process.env.NODE_ENV !== "production" && !V(o) && O(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const H = o.call(r, r);
    if (process.env.NODE_ENV !== "production" && Jo(H) && O(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !Z(H))
      process.env.NODE_ENV !== "production" && O("data() should return an object.");
    else if (e.data = ei(H), process.env.NODE_ENV !== "production")
      for (const q in H)
        Ne("Data", q), ai(q[0]) || Object.defineProperty(n, q, {
          configurable: !0,
          enumerable: !0,
          get: () => H[q],
          set: ce
        });
  }
  if (So = !0, i)
    for (const H in i) {
      const q = i[H], Re = V(q) ? q.bind(r, r) : V(q.get) ? q.get.bind(r, r) : ce;
      process.env.NODE_ENV !== "production" && Re === ce && O(`Computed property "${H}" has no getter.`);
      const Tn = !V(q) && V(q.set) ? q.set.bind(r) : process.env.NODE_ENV !== "production" ? () => {
        O(
          `Write operation failed: computed property "${H}" is readonly.`
        );
      } : ce, rr = Je({
        get: Re,
        set: Tn
      });
      Object.defineProperty(n, H, {
        enumerable: !0,
        configurable: !0,
        get: () => rr.value,
        set: (Rt) => rr.value = Rt
      }), process.env.NODE_ENV !== "production" && Ne("Computed", H);
    }
  if (a)
    for (const H in a)
      Ua(a[H], n, r, H);
  if (l) {
    const H = V(l) ? l.call(r) : l;
    Reflect.ownKeys(H).forEach((q) => {
      kc(q, H[q]);
    });
  }
  p && Ki(p, e, "c");
  function re(H, q) {
    R(q) ? q.forEach((Re) => H(Re.bind(r))) : q && H(q.bind(r));
  }
  if (re(bc, f), re(La, h), re(Ac, E), re(Nc, D), re(yc, I), re(vc, L), re(Mc, oe), re(Dc, ae), re(Cc, G), re(Oc, K), re(ka, N), re(wc, ee), R(Y))
    if (Y.length) {
      const H = e.exposed || (e.exposed = {});
      Y.forEach((q) => {
        Object.defineProperty(H, q, {
          get: () => r[q],
          set: (Re) => r[q] = Re
        });
      });
    } else
      e.exposed || (e.exposed = {});
  _ && e.render === ce && (e.render = _), te != null && (e.inheritAttrs = te), W && (e.components = W), de && (e.directives = de);
}
function Rc(e, t, r = ce) {
  R(e) && (e = _o(e));
  for (const n in e) {
    const o = e[n];
    let i;
    Z(o) ? "default" in o ? i = Wr(
      o.from || n,
      o.default,
      !0
    ) : i = Wr(o.from || n) : i = Wr(o), se(i) ? Object.defineProperty(t, n, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (s) => i.value = s
    }) : t[n] = i, process.env.NODE_ENV !== "production" && r("Inject", n);
  }
}
function Ki(e, t, r) {
  Te(
    R(e) ? e.map((n) => n.bind(t.proxy)) : e.bind(t.proxy),
    t,
    r
  );
}
function Ua(e, t, r, n) {
  const o = n.includes(".") ? Va(r, n) : () => r[n];
  if (ne(e)) {
    const i = t[e];
    V(i) ? Ln(o, i) : process.env.NODE_ENV !== "production" && O(`Invalid watch handler specified by key "${e}"`, i);
  } else if (V(e))
    Ln(o, e.bind(r));
  else if (Z(e))
    if (R(e))
      e.forEach((i) => Ua(i, t, r, n));
    else {
      const i = V(e.handler) ? e.handler.bind(r) : t[e.handler];
      V(i) ? Ln(o, i, e) : process.env.NODE_ENV !== "production" && O(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else
    process.env.NODE_ENV !== "production" && O(`Invalid watch option: "${n}"`, e);
}
function li(e) {
  const t = e.type, { mixins: r, extends: n } = t, {
    mixins: o,
    optionsCache: i,
    config: { optionMergeStrategies: s }
  } = e.appContext, a = i.get(t);
  let l;
  return a ? l = a : !o.length && !r && !n ? l = t : (l = {}, o.length && o.forEach(
    (u) => on(l, u, s, !0)
  ), on(l, t, s)), Z(t) && i.set(t, l), l;
}
function on(e, t, r, n = !1) {
  const { mixins: o, extends: i } = t;
  i && on(e, i, r, !0), o && o.forEach(
    (s) => on(e, s, r, !0)
  );
  for (const s in t)
    if (n && s === "expose")
      process.env.NODE_ENV !== "production" && O(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = jc[s] || r && r[s];
      e[s] = a ? a(e[s], t[s]) : t[s];
    }
  return e;
}
const jc = {
  data: Yi,
  props: Qi,
  emits: Qi,
  methods: pr,
  computed: pr,
  beforeCreate: ve,
  created: ve,
  beforeMount: ve,
  mounted: ve,
  beforeUpdate: ve,
  updated: ve,
  beforeDestroy: ve,
  beforeUnmount: ve,
  destroyed: ve,
  unmounted: ve,
  activated: ve,
  deactivated: ve,
  errorCaptured: ve,
  serverPrefetch: ve,
  components: pr,
  directives: pr,
  watch: Fc,
  provide: Yi,
  inject: Vc
};
function Yi(e, t) {
  return t ? e ? function() {
    return $(
      V(e) ? e.call(this, this) : e,
      V(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Vc(e, t) {
  return pr(_o(e), _o(t));
}
function _o(e) {
  if (R(e)) {
    const t = {};
    for (let r = 0; r < e.length; r++)
      t[e[r]] = e[r];
    return t;
  }
  return e;
}
function ve(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function pr(e, t) {
  return e ? $(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Qi(e, t) {
  return e ? R(e) && R(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : $(
    /* @__PURE__ */ Object.create(null),
    Wi(e),
    Wi(t != null ? t : {})
  ) : t;
}
function Fc(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  const r = $(/* @__PURE__ */ Object.create(null), e);
  for (const n in t)
    r[n] = ve(e[n], t[n]);
  return r;
}
function Ha() {
  return {
    app: null,
    config: {
      isNativeTag: ea,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Bc = 0;
function Lc(e, t) {
  return function(n, o = null) {
    V(n) || (n = $({}, n)), o != null && !Z(o) && (process.env.NODE_ENV !== "production" && O("root props passed to app.mount() must be an object."), o = null);
    const i = Ha();
    process.env.NODE_ENV !== "production" && Object.defineProperty(i.config, "unwrapInjectedRef", {
      get() {
        return !0;
      },
      set() {
        O(
          "app.config.unwrapInjectedRef has been deprecated. 3.3 now alawys unwraps injected refs in Options API."
        );
      }
    });
    const s = /* @__PURE__ */ new Set();
    let a = !1;
    const l = i.app = {
      _uid: Bc++,
      _component: n,
      _props: o,
      _container: null,
      _context: i,
      _instance: null,
      version: os,
      get config() {
        return i.config;
      },
      set config(u) {
        process.env.NODE_ENV !== "production" && O(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(u, ...p) {
        return s.has(u) ? process.env.NODE_ENV !== "production" && O("Plugin has already been applied to target app.") : u && V(u.install) ? (s.add(u), u.install(l, ...p)) : V(u) ? (s.add(u), u(l, ...p)) : process.env.NODE_ENV !== "production" && O(
          'A plugin must either be a function or an object with an "install" function.'
        ), l;
      },
      mixin(u) {
        return i.mixins.includes(u) ? process.env.NODE_ENV !== "production" && O(
          "Mixin has already been applied to target app" + (u.name ? `: ${u.name}` : "")
        ) : i.mixins.push(u), l;
      },
      component(u, p) {
        return process.env.NODE_ENV !== "production" && Vo(u, i.config), p ? (process.env.NODE_ENV !== "production" && i.components[u] && O(`Component "${u}" has already been registered in target app.`), i.components[u] = p, l) : i.components[u];
      },
      directive(u, p) {
        return process.env.NODE_ENV !== "production" && Fa(u), p ? (process.env.NODE_ENV !== "production" && i.directives[u] && O(`Directive "${u}" has already been registered in target app.`), i.directives[u] = p, l) : i.directives[u];
      },
      mount(u, p, f) {
        if (a)
          process.env.NODE_ENV !== "production" && O(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && u.__vue_app__ && O(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const h = $e(
            n,
            o
          );
          return h.appContext = i, process.env.NODE_ENV !== "production" && (i.reload = () => {
            e(pt(h), u, f);
          }), p && t ? t(h, u) : e(h, u, f), a = !0, l._container = u, u.__vue_app__ = l, process.env.NODE_ENV !== "production" && (l._instance = h.component, Xu(l, os)), di(h.component) || h.component.proxy;
        }
      },
      unmount() {
        a ? (e(null, l._container), process.env.NODE_ENV !== "production" && (l._instance = null, Zu(l)), delete l._container.__vue_app__) : process.env.NODE_ENV !== "production" && O("Cannot unmount an app that is not mounted.");
      },
      provide(u, p) {
        return process.env.NODE_ENV !== "production" && u in i.provides && O(
          `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
        ), i.provides[u] = p, l;
      },
      runWithContext(u) {
        sn = l;
        try {
          return u();
        } finally {
          sn = null;
        }
      }
    };
    return l;
  };
}
let sn = null;
function kc(e, t) {
  if (!fe)
    process.env.NODE_ENV !== "production" && O("provide() can only be used inside setup().");
  else {
    let r = fe.provides;
    const n = fe.parent && fe.parent.provides;
    n === r && (r = fe.provides = Object.create(n)), r[e] = t;
  }
}
function Wr(e, t, r = !1) {
  const n = fe || De;
  if (n || sn) {
    const o = n ? n.parent == null ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : sn._context.provides;
    if (o && e in o)
      return o[e];
    if (arguments.length > 1)
      return r && V(t) ? t.call(n && n.proxy) : t;
    process.env.NODE_ENV !== "production" && O(`injection "${String(e)}" not found.`);
  } else
    process.env.NODE_ENV !== "production" && O("inject() can only be used inside setup() or functional components.");
}
function zc(e, t, r, n = !1) {
  const o = {}, i = {};
  Gr(i, Dn, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), qa(e, t, o, i);
  for (const s in e.propsOptions[0])
    s in o || (o[s] = void 0);
  process.env.NODE_ENV !== "production" && Ka(t || {}, o, e), r ? e.props = n ? o : xu(o) : e.type.props ? e.props = o : e.props = i, e.attrs = i;
}
function Uc(e) {
  for (; e; ) {
    if (e.type.__hmrId)
      return !0;
    e = e.parent;
  }
}
function Hc(e, t, r, n) {
  const {
    props: o,
    attrs: i,
    vnode: { patchFlag: s }
  } = e, a = B(o), [l] = e.propsOptions;
  let u = !1;
  if (!(process.env.NODE_ENV !== "production" && Uc(e)) && (n || s > 0) && !(s & 16)) {
    if (s & 8) {
      const p = e.vnode.dynamicProps;
      for (let f = 0; f < p.length; f++) {
        let h = p[f];
        if (On(e.emitsOptions, h))
          continue;
        const E = t[h];
        if (l)
          if (k(i, h))
            E !== i[h] && (i[h] = E, u = !0);
          else {
            const D = Xt(h);
            o[D] = To(
              l,
              a,
              D,
              E,
              e,
              !1
            );
          }
        else
          E !== i[h] && (i[h] = E, u = !0);
      }
    }
  } else {
    qa(e, t, o, i) && (u = !0);
    let p;
    for (const f in a)
      (!t || !k(t, f) && ((p = ut(f)) === f || !k(t, p))) && (l ? r && (r[f] !== void 0 || r[p] !== void 0) && (o[f] = To(
        l,
        a,
        f,
        void 0,
        e,
        !0
      )) : delete o[f]);
    if (i !== a)
      for (const f in i)
        (!t || !k(t, f) && !0) && (delete i[f], u = !0);
  }
  u && He(e, "set", "$attrs"), process.env.NODE_ENV !== "production" && Ka(t || {}, o, e);
}
function qa(e, t, r, n) {
  const [o, i] = e.propsOptions;
  let s = !1, a;
  if (t)
    for (let l in t) {
      if (zr(l))
        continue;
      const u = t[l];
      let p;
      o && k(o, p = Xt(l)) ? !i || !i.includes(p) ? r[p] = u : (a || (a = {}))[p] = u : On(e.emitsOptions, l) || (!(l in n) || u !== n[l]) && (n[l] = u, s = !0);
    }
  if (i) {
    const l = B(r), u = a || X;
    for (let p = 0; p < i.length; p++) {
      const f = i[p];
      r[f] = To(
        o,
        l,
        f,
        u[f],
        e,
        !k(u, f)
      );
    }
  }
  return s;
}
function To(e, t, r, n, o, i) {
  const s = e[r];
  if (s != null) {
    const a = k(s, "default");
    if (a && n === void 0) {
      const l = s.default;
      if (s.type !== Function && !s.skipFactory && V(l)) {
        const { propsDefaults: u } = o;
        r in u ? n = u[r] : (Zt(o), n = u[r] = l.call(
          null,
          t
        ), Mt());
      } else
        n = l;
    }
    s[0] && (i && !a ? n = !1 : s[1] && (n === "" || n === ut(r)) && (n = !0));
  }
  return n;
}
function Wa(e, t, r = !1) {
  const n = t.propsCache, o = n.get(e);
  if (o)
    return o;
  const i = e.props, s = {}, a = [];
  let l = !1;
  if (!V(e)) {
    const p = (f) => {
      l = !0;
      const [h, E] = Wa(f, t, !0);
      $(s, h), E && a.push(...E);
    };
    !r && t.mixins.length && t.mixins.forEach(p), e.extends && p(e.extends), e.mixins && e.mixins.forEach(p);
  }
  if (!i && !l)
    return Z(e) && n.set(e, Kt), Kt;
  if (R(i))
    for (let p = 0; p < i.length; p++) {
      process.env.NODE_ENV !== "production" && !ne(i[p]) && O("props must be strings when using array syntax.", i[p]);
      const f = Xt(i[p]);
      Ji(f) && (s[f] = X);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !Z(i) && O("invalid props options", i);
    for (const p in i) {
      const f = Xt(p);
      if (Ji(f)) {
        const h = i[p], E = s[f] = R(h) || V(h) ? { type: h } : $({}, h);
        if (E) {
          const D = Zi(Boolean, E.type), I = Zi(String, E.type);
          E[0] = D > -1, E[1] = I < 0 || D < I, (D > -1 || k(E, "default")) && a.push(f);
        }
      }
    }
  }
  const u = [s, a];
  return Z(e) && n.set(e, u), u;
}
function Ji(e) {
  return e[0] !== "$" ? !0 : (process.env.NODE_ENV !== "production" && O(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function Po(e) {
  const t = e && e.toString().match(/^\s*(function|class) (\w+)/);
  return t ? t[2] : e === null ? "null" : "";
}
function Xi(e, t) {
  return Po(e) === Po(t);
}
function Zi(e, t) {
  return R(t) ? t.findIndex((r) => Xi(r, e)) : V(t) && Xi(t, e) ? 0 : -1;
}
function Ka(e, t, r) {
  const n = B(t), o = r.propsOptions[0];
  for (const i in o) {
    let s = o[i];
    s != null && qc(
      i,
      n[i],
      s,
      !k(e, i) && !k(e, ut(i))
    );
  }
}
function qc(e, t, r, n) {
  const { type: o, required: i, validator: s, skipCheck: a } = r;
  if (i && n) {
    O('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !i)) {
    if (o != null && o !== !0 && !a) {
      let l = !1;
      const u = R(o) ? o : [o], p = [];
      for (let f = 0; f < u.length && !l; f++) {
        const { valid: h, expectedType: E } = Kc(t, u[f]);
        p.push(E || ""), l = h;
      }
      if (!l) {
        O(Yc(e, t, p));
        return;
      }
    }
    s && !s(t) && O('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Wc = /* @__PURE__ */ dt(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Kc(e, t) {
  let r;
  const n = Po(t);
  if (Wc(n)) {
    const o = typeof e;
    r = o === n.toLowerCase(), !r && o === "object" && (r = e instanceof t);
  } else
    n === "Object" ? r = Z(e) : n === "Array" ? r = R(e) : n === "null" ? r = e === null : r = e instanceof t;
  return {
    valid: r,
    expectedType: n
  };
}
function Yc(e, t, r) {
  let n = `Invalid prop: type check failed for prop "${e}". Expected ${r.map(mn).join(" | ")}`;
  const o = r[0], i = Xo(t), s = $i(t, o), a = $i(t, i);
  return r.length === 1 && Gi(o) && !Qc(o, i) && (n += ` with value ${s}`), n += `, got ${i} `, Gi(i) && (n += `with value ${a}.`), n;
}
function $i(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Gi(e) {
  return ["string", "number", "boolean"].some((r) => e.toLowerCase() === r);
}
function Qc(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const Ya = (e) => e[0] === "_" || e === "$stable", ui = (e) => R(e) ? e.map(Se) : [Se(e)], Jc = (e, t, r) => {
  if (t._n)
    return t;
  const n = ac((...o) => (process.env.NODE_ENV !== "production" && fe && O(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), ui(t(...o))), r);
  return n._c = !1, n;
}, Qa = (e, t, r) => {
  const n = e._ctx;
  for (const o in e) {
    if (Ya(o))
      continue;
    const i = e[o];
    if (V(i))
      t[o] = Jc(o, i, n);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && O(
        `Non-function value encountered for slot "${o}". Prefer function slots for better performance.`
      );
      const s = ui(i);
      t[o] = () => s;
    }
  }
}, Ja = (e, t) => {
  process.env.NODE_ENV !== "production" && !si(e.vnode) && O(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const r = ui(t);
  e.slots.default = () => r;
}, Xc = (e, t) => {
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (e.slots = B(t), Gr(t, "_", r)) : Qa(
      t,
      e.slots = {}
    );
  } else
    e.slots = {}, t && Ja(e, t);
  Gr(e.slots, Dn, 1);
}, Zc = (e, t, r) => {
  const { vnode: n, slots: o } = e;
  let i = !0, s = X;
  if (n.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && Ct ? ($(o, t), He(e, "set", "$slots")) : r && a === 1 ? i = !1 : ($(o, t), !r && a === 1 && delete o._) : (i = !t.$stable, Qa(t, o)), s = t;
  } else
    t && (Ja(e, t), s = { default: 1 });
  if (i)
    for (const a in o)
      !Ya(a) && !(a in s) && delete o[a];
};
function Ro(e, t, r, n, o = !1) {
  if (R(e)) {
    e.forEach(
      (h, E) => Ro(
        h,
        t && (R(t) ? t[E] : t),
        r,
        n,
        o
      )
    );
    return;
  }
  if (qr(n) && !o)
    return;
  const i = n.shapeFlag & 4 ? di(n.component) || n.component.proxy : n.el, s = o ? null : i, { i: a, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    O(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const u = t && t.r, p = a.refs === X ? a.refs = {} : a.refs, f = a.setupState;
  if (u != null && u !== l && (ne(u) ? (p[u] = null, k(f, u) && (f[u] = null)) : se(u) && (u.value = null)), V(l))
    Ze(l, a, 12, [s, p]);
  else {
    const h = ne(l), E = se(l);
    if (h || E) {
      const D = () => {
        if (e.f) {
          const I = h ? k(f, l) ? f[l] : p[l] : l.value;
          o ? R(I) && Yo(I, i) : R(I) ? I.includes(i) || I.push(i) : h ? (p[l] = [i], k(f, l) && (f[l] = p[l])) : (l.value = [i], e.k && (p[e.k] = l.value));
        } else
          h ? (p[l] = s, k(f, l) && (f[l] = s)) : E ? (l.value = s, e.k && (p[e.k] = s)) : process.env.NODE_ENV !== "production" && O("Invalid template ref type:", l, `(${typeof l})`);
      };
      s ? (D.id = -1, be(D, r)) : D();
    } else
      process.env.NODE_ENV !== "production" && O("Invalid template ref type:", l, `(${typeof l})`);
  }
}
let sr, st;
function Ke(e, t) {
  e.appContext.config.performance && an() && st.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && tc(e, t, an() ? st.now() : Date.now());
}
function Ye(e, t) {
  if (e.appContext.config.performance && an()) {
    const r = `vue-${t}-${e.uid}`, n = r + ":end";
    st.mark(n), st.measure(
      `<${Mn(e, e.type)}> ${t}`,
      r,
      n
    ), st.clearMarks(r), st.clearMarks(n);
  }
  process.env.NODE_ENV !== "production" && rc(e, t, an() ? st.now() : Date.now());
}
function an() {
  return sr !== void 0 || (typeof window < "u" && window.performance ? (sr = !0, st = window.performance) : sr = !1), sr;
}
function $c() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const be = hc;
function Gc(e) {
  return ef(e);
}
function ef(e, t) {
  $c();
  const r = en();
  r.__VUE__ = !0, process.env.NODE_ENV !== "production" && Sa(r.__VUE_DEVTOOLS_GLOBAL_HOOK__, r);
  const {
    insert: n,
    remove: o,
    patchProp: i,
    createElement: s,
    createText: a,
    createComment: l,
    setText: u,
    setElementText: p,
    parentNode: f,
    nextSibling: h,
    setScopeId: E = ce,
    insertStaticContent: D
  } = e, I = (c, d, m, y = null, g = null, A = null, C = !1, b = null, w = process.env.NODE_ENV !== "production" && Ct ? !1 : !!d.dynamicChildren) => {
    if (c === d)
      return;
    c && !ar(c, d) && (y = Sr(c), et(c, g, A, !0), c = null), d.patchFlag === -2 && (w = !1, d.dynamicChildren = null);
    const { type: v, ref: S, shapeFlag: M } = d;
    switch (v) {
      case Mr:
        L(c, d, m, y);
        break;
      case we:
        x(c, d, m, y);
        break;
      case Yr:
        c == null ? K(d, m, y, C) : process.env.NODE_ENV !== "production" && j(c, d, m, C);
        break;
      case Le:
        de(
          c,
          d,
          m,
          y,
          g,
          A,
          C,
          b,
          w
        );
        break;
      default:
        M & 1 ? ae(
          c,
          d,
          m,
          y,
          g,
          A,
          C,
          b,
          w
        ) : M & 6 ? Ae(
          c,
          d,
          m,
          y,
          g,
          A,
          C,
          b,
          w
        ) : M & 64 || M & 128 ? v.process(
          c,
          d,
          m,
          y,
          g,
          A,
          C,
          b,
          w,
          jt
        ) : process.env.NODE_ENV !== "production" && O("Invalid VNode type:", v, `(${typeof v})`);
    }
    S != null && g && Ro(S, c && c.ref, A, d || c, !d);
  }, L = (c, d, m, y) => {
    if (c == null)
      n(
        d.el = a(d.children),
        m,
        y
      );
    else {
      const g = d.el = c.el;
      d.children !== c.children && u(g, d.children);
    }
  }, x = (c, d, m, y) => {
    c == null ? n(
      d.el = l(d.children || ""),
      m,
      y
    ) : d.el = c.el;
  }, K = (c, d, m, y) => {
    [c.el, c.anchor] = D(
      c.children,
      d,
      m,
      y,
      c.el,
      c.anchor
    );
  }, j = (c, d, m, y) => {
    if (d.children !== c.children) {
      const g = h(c.anchor);
      _(c), [d.el, d.anchor] = D(
        d.children,
        m,
        g,
        y
      );
    } else
      d.el = c.el, d.anchor = c.anchor;
  }, N = ({ el: c, anchor: d }, m, y) => {
    let g;
    for (; c && c !== d; )
      g = h(c), n(c, m, y), c = g;
    n(d, m, y);
  }, _ = ({ el: c, anchor: d }) => {
    let m;
    for (; c && c !== d; )
      m = h(c), o(c), c = m;
    o(d);
  }, ae = (c, d, m, y, g, A, C, b, w) => {
    C = C || d.type === "svg", c == null ? G(
      d,
      m,
      y,
      g,
      A,
      C,
      b,
      w
    ) : Y(
      c,
      d,
      g,
      A,
      C,
      b,
      w
    );
  }, G = (c, d, m, y, g, A, C, b) => {
    let w, v;
    const { type: S, props: M, shapeFlag: P, transition: F, dirs: z } = c;
    if (w = c.el = s(
      c.type,
      A,
      M && M.is,
      M
    ), P & 8 ? p(w, c.children) : P & 16 && ee(
      c.children,
      w,
      null,
      y,
      g,
      A && S !== "foreignObject",
      C,
      b
    ), z && mt(c, null, y, "created"), oe(w, c, c.scopeId, C, y), M) {
      for (const Q in M)
        Q !== "value" && !zr(Q) && i(
          w,
          Q,
          null,
          M[Q],
          A,
          c.children,
          y,
          g,
          We
        );
      "value" in M && i(w, "value", null, M.value), (v = M.onVnodeBeforeMount) && Ve(v, y, c);
    }
    process.env.NODE_ENV !== "production" && (Object.defineProperty(w, "__vnode", {
      value: c,
      enumerable: !1
    }), Object.defineProperty(w, "__vueParentComponent", {
      value: y,
      enumerable: !1
    })), z && mt(c, null, y, "beforeMount");
    const J = (!g || g && !g.pendingBranch) && F && !F.persisted;
    J && F.beforeEnter(w), n(w, d, m), ((v = M && M.onVnodeMounted) || J || z) && be(() => {
      v && Ve(v, y, c), J && F.enter(w), z && mt(c, null, y, "mounted");
    }, g);
  }, oe = (c, d, m, y, g) => {
    if (m && E(c, m), y)
      for (let A = 0; A < y.length; A++)
        E(c, y[A]);
    if (g) {
      let A = g.subTree;
      if (process.env.NODE_ENV !== "production" && A.patchFlag > 0 && A.patchFlag & 2048 && (A = Ra(A.children) || A), d === A) {
        const C = g.vnode;
        oe(
          c,
          C,
          C.scopeId,
          C.slotScopeIds,
          g.parent
        );
      }
    }
  }, ee = (c, d, m, y, g, A, C, b, w = 0) => {
    for (let v = w; v < c.length; v++) {
      const S = c[v] = b ? ot(c[v]) : Se(c[v]);
      I(
        null,
        S,
        d,
        m,
        y,
        g,
        A,
        C,
        b
      );
    }
  }, Y = (c, d, m, y, g, A, C) => {
    const b = d.el = c.el;
    let { patchFlag: w, dynamicChildren: v, dirs: S } = d;
    w |= c.patchFlag & 16;
    const M = c.props || X, P = d.props || X;
    let F;
    m && gt(m, !1), (F = P.onVnodeBeforeUpdate) && Ve(F, m, d, c), S && mt(d, c, m, "beforeUpdate"), m && gt(m, !0), process.env.NODE_ENV !== "production" && Ct && (w = 0, C = !1, v = null);
    const z = g && d.type !== "foreignObject";
    if (v ? (te(
      c.dynamicChildren,
      v,
      b,
      m,
      y,
      z,
      A
    ), process.env.NODE_ENV !== "production" && Kr(c, d)) : C || Re(
      c,
      d,
      b,
      null,
      m,
      y,
      z,
      A,
      !1
    ), w > 0) {
      if (w & 16)
        W(
          b,
          d,
          M,
          P,
          m,
          y,
          g
        );
      else if (w & 2 && M.class !== P.class && i(b, "class", null, P.class, g), w & 4 && i(b, "style", M.style, P.style, g), w & 8) {
        const J = d.dynamicProps;
        for (let Q = 0; Q < J.length; Q++) {
          const ie = J[Q], Me = M[ie], Vt = P[ie];
          (Vt !== Me || ie === "value") && i(
            b,
            ie,
            Me,
            Vt,
            g,
            c.children,
            m,
            y,
            We
          );
        }
      }
      w & 1 && c.children !== d.children && p(b, d.children);
    } else
      !C && v == null && W(
        b,
        d,
        M,
        P,
        m,
        y,
        g
      );
    ((F = P.onVnodeUpdated) || S) && be(() => {
      F && Ve(F, m, d, c), S && mt(d, c, m, "updated");
    }, y);
  }, te = (c, d, m, y, g, A, C) => {
    for (let b = 0; b < d.length; b++) {
      const w = c[b], v = d[b], S = w.el && (w.type === Le || !ar(w, v) || w.shapeFlag & 70) ? f(w.el) : m;
      I(
        w,
        v,
        S,
        null,
        y,
        g,
        A,
        C,
        !0
      );
    }
  }, W = (c, d, m, y, g, A, C) => {
    if (m !== y) {
      if (m !== X)
        for (const b in m)
          !zr(b) && !(b in y) && i(
            c,
            b,
            m[b],
            null,
            C,
            d.children,
            g,
            A,
            We
          );
      for (const b in y) {
        if (zr(b))
          continue;
        const w = y[b], v = m[b];
        w !== v && b !== "value" && i(
          c,
          b,
          v,
          w,
          C,
          d.children,
          g,
          A,
          We
        );
      }
      "value" in y && i(c, "value", m.value, y.value);
    }
  }, de = (c, d, m, y, g, A, C, b, w) => {
    const v = d.el = c ? c.el : a(""), S = d.anchor = c ? c.anchor : a("");
    let { patchFlag: M, dynamicChildren: P, slotScopeIds: F } = d;
    process.env.NODE_ENV !== "production" && (Ct || M & 2048) && (M = 0, w = !1, P = null), F && (b = b ? b.concat(F) : F), c == null ? (n(v, m, y), n(S, m, y), ee(
      d.children,
      m,
      S,
      g,
      A,
      C,
      b,
      w
    )) : M > 0 && M & 64 && P && c.dynamicChildren ? (te(
      c.dynamicChildren,
      P,
      m,
      g,
      A,
      C,
      b
    ), process.env.NODE_ENV !== "production" ? Kr(c, d) : (d.key != null || g && d === g.subTree) && Kr(
      c,
      d,
      !0
    )) : Re(
      c,
      d,
      m,
      S,
      g,
      A,
      C,
      b,
      w
    );
  }, Ae = (c, d, m, y, g, A, C, b, w) => {
    d.slotScopeIds = b, c == null ? d.shapeFlag & 512 ? g.ctx.activate(
      d,
      m,
      y,
      C,
      w
    ) : Ne(
      d,
      m,
      y,
      g,
      A,
      C,
      w
    ) : re(c, d, w);
  }, Ne = (c, d, m, y, g, A, C) => {
    const b = c.component = ff(
      c,
      y,
      g
    );
    if (process.env.NODE_ENV !== "production" && b.type.__hmrId && Ku(b), process.env.NODE_ENV !== "production" && (Ur(c), Ke(b, "mount")), si(c) && (b.ctx.renderer = jt), process.env.NODE_ENV !== "production" && Ke(b, "init"), df(b), process.env.NODE_ENV !== "production" && Ye(b, "init"), b.asyncDep) {
      if (g && g.registerDep(b, H), !c.el) {
        const w = b.subTree = $e(we);
        x(null, w, d, m);
      }
      return;
    }
    H(
      b,
      c,
      d,
      m,
      g,
      A,
      C
    ), process.env.NODE_ENV !== "production" && (Hr(), Ye(b, "mount"));
  }, re = (c, d, m) => {
    const y = d.component = c.component;
    if (fc(c, d, m))
      if (y.asyncDep && !y.asyncResolved) {
        process.env.NODE_ENV !== "production" && Ur(d), q(y, d, m), process.env.NODE_ENV !== "production" && Hr();
        return;
      } else
        y.next = d, qu(y.update), y.update();
    else
      d.el = c.el, y.vnode = d;
  }, H = (c, d, m, y, g, A, C) => {
    const b = () => {
      if (c.isMounted) {
        let { next: S, bu: M, u: P, parent: F, vnode: z } = c, J = S, Q;
        process.env.NODE_ENV !== "production" && Ur(S || c.vnode), gt(c, !1), S ? (S.el = z.el, q(c, S, C)) : S = z, M && or(M), (Q = S.props && S.props.onVnodeBeforeUpdate) && Ve(Q, F, S, z), gt(c, !0), process.env.NODE_ENV !== "production" && Ke(c, "render");
        const ie = Bn(c);
        process.env.NODE_ENV !== "production" && Ye(c, "render");
        const Me = c.subTree;
        c.subTree = ie, process.env.NODE_ENV !== "production" && Ke(c, "patch"), I(
          Me,
          ie,
          f(Me.el),
          Sr(Me),
          c,
          g,
          A
        ), process.env.NODE_ENV !== "production" && Ye(c, "patch"), S.el = ie.el, J === null && pc(c, ie.el), P && be(P, g), (Q = S.props && S.props.onVnodeUpdated) && be(
          () => Ve(Q, F, S, z),
          g
        ), process.env.NODE_ENV !== "production" && _a(c), process.env.NODE_ENV !== "production" && Hr();
      } else {
        let S;
        const { el: M, props: P } = d, { bm: F, m: z, parent: J } = c, Q = qr(d);
        if (gt(c, !1), F && or(F), !Q && (S = P && P.onVnodeBeforeMount) && Ve(S, J, d), gt(c, !0), M && jn) {
          const ie = () => {
            process.env.NODE_ENV !== "production" && Ke(c, "render"), c.subTree = Bn(c), process.env.NODE_ENV !== "production" && Ye(c, "render"), process.env.NODE_ENV !== "production" && Ke(c, "hydrate"), jn(
              M,
              c.subTree,
              c,
              g,
              null
            ), process.env.NODE_ENV !== "production" && Ye(c, "hydrate");
          };
          Q ? d.type.__asyncLoader().then(
            () => !c.isUnmounted && ie()
          ) : ie();
        } else {
          process.env.NODE_ENV !== "production" && Ke(c, "render");
          const ie = c.subTree = Bn(c);
          process.env.NODE_ENV !== "production" && Ye(c, "render"), process.env.NODE_ENV !== "production" && Ke(c, "patch"), I(
            null,
            ie,
            m,
            y,
            c,
            g,
            A
          ), process.env.NODE_ENV !== "production" && Ye(c, "patch"), d.el = ie.el;
        }
        if (z && be(z, g), !Q && (S = P && P.onVnodeMounted)) {
          const ie = d;
          be(
            () => Ve(S, J, ie),
            g
          );
        }
        (d.shapeFlag & 256 || J && qr(J.vnode) && J.vnode.shapeFlag & 256) && c.a && be(c.a, g), c.isMounted = !0, process.env.NODE_ENV !== "production" && $u(c), d = m = y = null;
      }
    }, w = c.effect = new $o(
      b,
      () => Nn(v),
      c.scope
    ), v = c.update = () => w.run();
    v.id = c.uid, gt(c, !0), process.env.NODE_ENV !== "production" && (w.onTrack = c.rtc ? (S) => or(c.rtc, S) : void 0, w.onTrigger = c.rtg ? (S) => or(c.rtg, S) : void 0, v.ownerInstance = c), v();
  }, q = (c, d, m) => {
    d.component = c;
    const y = c.vnode.props;
    c.vnode = d, c.next = null, Hc(c, d.props, y, m), Zc(c, d.children, m), _t(), zi(), Tt();
  }, Re = (c, d, m, y, g, A, C, b, w = !1) => {
    const v = c && c.children, S = c ? c.shapeFlag : 0, M = d.children, { patchFlag: P, shapeFlag: F } = d;
    if (P > 0) {
      if (P & 128) {
        rr(
          v,
          M,
          m,
          y,
          g,
          A,
          C,
          b,
          w
        );
        return;
      } else if (P & 256) {
        Tn(
          v,
          M,
          m,
          y,
          g,
          A,
          C,
          b,
          w
        );
        return;
      }
    }
    F & 8 ? (S & 16 && We(v, g, A), M !== v && p(m, M)) : S & 16 ? F & 16 ? rr(
      v,
      M,
      m,
      y,
      g,
      A,
      C,
      b,
      w
    ) : We(v, g, A, !0) : (S & 8 && p(m, ""), F & 16 && ee(
      M,
      m,
      y,
      g,
      A,
      C,
      b,
      w
    ));
  }, Tn = (c, d, m, y, g, A, C, b, w) => {
    c = c || Kt, d = d || Kt;
    const v = c.length, S = d.length, M = Math.min(v, S);
    let P;
    for (P = 0; P < M; P++) {
      const F = d[P] = w ? ot(d[P]) : Se(d[P]);
      I(
        c[P],
        F,
        m,
        null,
        g,
        A,
        C,
        b,
        w
      );
    }
    v > S ? We(
      c,
      g,
      A,
      !0,
      !1,
      M
    ) : ee(
      d,
      m,
      y,
      g,
      A,
      C,
      b,
      w,
      M
    );
  }, rr = (c, d, m, y, g, A, C, b, w) => {
    let v = 0;
    const S = d.length;
    let M = c.length - 1, P = S - 1;
    for (; v <= M && v <= P; ) {
      const F = c[v], z = d[v] = w ? ot(d[v]) : Se(d[v]);
      if (ar(F, z))
        I(
          F,
          z,
          m,
          null,
          g,
          A,
          C,
          b,
          w
        );
      else
        break;
      v++;
    }
    for (; v <= M && v <= P; ) {
      const F = c[M], z = d[P] = w ? ot(d[P]) : Se(d[P]);
      if (ar(F, z))
        I(
          F,
          z,
          m,
          null,
          g,
          A,
          C,
          b,
          w
        );
      else
        break;
      M--, P--;
    }
    if (v > M) {
      if (v <= P) {
        const F = P + 1, z = F < S ? d[F].el : y;
        for (; v <= P; )
          I(
            null,
            d[v] = w ? ot(d[v]) : Se(d[v]),
            m,
            z,
            g,
            A,
            C,
            b,
            w
          ), v++;
      }
    } else if (v > P)
      for (; v <= M; )
        et(c[v], g, A, !0), v++;
    else {
      const F = v, z = v, J = /* @__PURE__ */ new Map();
      for (v = z; v <= P; v++) {
        const ye = d[v] = w ? ot(d[v]) : Se(d[v]);
        ye.key != null && (process.env.NODE_ENV !== "production" && J.has(ye.key) && O(
          "Duplicate keys found during update:",
          JSON.stringify(ye.key),
          "Make sure keys are unique."
        ), J.set(ye.key, v));
      }
      let Q, ie = 0;
      const Me = P - z + 1;
      let Vt = !1, Mi = 0;
      const nr = new Array(Me);
      for (v = 0; v < Me; v++)
        nr[v] = 0;
      for (v = F; v <= M; v++) {
        const ye = c[v];
        if (ie >= Me) {
          et(ye, g, A, !0);
          continue;
        }
        let je;
        if (ye.key != null)
          je = J.get(ye.key);
        else
          for (Q = z; Q <= P; Q++)
            if (nr[Q - z] === 0 && ar(ye, d[Q])) {
              je = Q;
              break;
            }
        je === void 0 ? et(ye, g, A, !0) : (nr[je - z] = v + 1, je >= Mi ? Mi = je : Vt = !0, I(
          ye,
          d[je],
          m,
          null,
          g,
          A,
          C,
          b,
          w
        ), ie++);
      }
      const Ii = Vt ? tf(nr) : Kt;
      for (Q = Ii.length - 1, v = Me - 1; v >= 0; v--) {
        const ye = z + v, je = d[ye], xi = ye + 1 < S ? d[ye + 1].el : y;
        nr[v] === 0 ? I(
          null,
          je,
          m,
          xi,
          g,
          A,
          C,
          b,
          w
        ) : Vt && (Q < 0 || v !== Ii[Q] ? Rt(je, m, xi, 2) : Q--);
      }
    }
  }, Rt = (c, d, m, y, g = null) => {
    const { el: A, type: C, transition: b, children: w, shapeFlag: v } = c;
    if (v & 6) {
      Rt(c.component.subTree, d, m, y);
      return;
    }
    if (v & 128) {
      c.suspense.move(d, m, y);
      return;
    }
    if (v & 64) {
      C.move(c, d, m, jt);
      return;
    }
    if (C === Le) {
      n(A, d, m);
      for (let M = 0; M < w.length; M++)
        Rt(w[M], d, m, y);
      n(c.anchor, d, m);
      return;
    }
    if (C === Yr) {
      N(c, d, m);
      return;
    }
    if (y !== 2 && v & 1 && b)
      if (y === 0)
        b.beforeEnter(A), n(A, d, m), be(() => b.enter(A), g);
      else {
        const { leave: M, delayLeave: P, afterLeave: F } = b, z = () => n(A, d, m), J = () => {
          M(A, () => {
            z(), F && F();
          });
        };
        P ? P(A, z, J) : J();
      }
    else
      n(A, d, m);
  }, et = (c, d, m, y = !1, g = !1) => {
    const {
      type: A,
      props: C,
      ref: b,
      children: w,
      dynamicChildren: v,
      shapeFlag: S,
      patchFlag: M,
      dirs: P
    } = c;
    if (b != null && Ro(b, null, m, c, !0), S & 256) {
      d.ctx.deactivate(c);
      return;
    }
    const F = S & 1 && P, z = !qr(c);
    let J;
    if (z && (J = C && C.onVnodeBeforeUnmount) && Ve(J, d, c), S & 6)
      Vl(c.component, m, y);
    else {
      if (S & 128) {
        c.suspense.unmount(m, y);
        return;
      }
      F && mt(c, null, d, "beforeUnmount"), S & 64 ? c.type.remove(
        c,
        d,
        m,
        g,
        jt,
        y
      ) : v && (A !== Le || M > 0 && M & 64) ? We(
        v,
        d,
        m,
        !1,
        !0
      ) : (A === Le && M & 384 || !g && S & 16) && We(w, d, m), y && Pn(c);
    }
    (z && (J = C && C.onVnodeUnmounted) || F) && be(() => {
      J && Ve(J, d, c), F && mt(c, null, d, "unmounted");
    }, m);
  }, Pn = (c) => {
    const { type: d, el: m, anchor: y, transition: g } = c;
    if (d === Le) {
      process.env.NODE_ENV !== "production" && c.patchFlag > 0 && c.patchFlag & 2048 && g && !g.persisted ? c.children.forEach((C) => {
        C.type === we ? o(C.el) : Pn(C);
      }) : jl(m, y);
      return;
    }
    if (d === Yr) {
      _(c);
      return;
    }
    const A = () => {
      o(m), g && !g.persisted && g.afterLeave && g.afterLeave();
    };
    if (c.shapeFlag & 1 && g && !g.persisted) {
      const { leave: C, delayLeave: b } = g, w = () => C(m, A);
      b ? b(c.el, A, w) : w();
    } else
      A();
  }, jl = (c, d) => {
    let m;
    for (; c !== d; )
      m = h(c), o(c), c = m;
    o(d);
  }, Vl = (c, d, m) => {
    process.env.NODE_ENV !== "production" && c.type.__hmrId && Yu(c);
    const { bum: y, scope: g, update: A, subTree: C, um: b } = c;
    y && or(y), g.stop(), A && (A.active = !1, et(C, c, d, m)), b && be(b, d), be(() => {
      c.isUnmounted = !0;
    }, d), d && d.pendingBranch && !d.isUnmounted && c.asyncDep && !c.asyncResolved && c.suspenseId === d.pendingId && (d.deps--, d.deps === 0 && d.resolve()), process.env.NODE_ENV !== "production" && ec(c);
  }, We = (c, d, m, y = !1, g = !1, A = 0) => {
    for (let C = A; C < c.length; C++)
      et(c[C], d, m, y, g);
  }, Sr = (c) => c.shapeFlag & 6 ? Sr(c.component.subTree) : c.shapeFlag & 128 ? c.suspense.next() : h(c.anchor || c.el), Di = (c, d, m) => {
    c == null ? d._vnode && et(d._vnode, null, null, !0) : I(d._vnode || null, c, d, null, null, null, m), zi(), Ma(), d._vnode = c;
  }, jt = {
    p: I,
    um: et,
    m: Rt,
    r: Pn,
    mt: Ne,
    mc: ee,
    pc: Re,
    pbc: te,
    n: Sr,
    o: e
  };
  let Rn, jn;
  return t && ([Rn, jn] = t(
    jt
  )), {
    render: Di,
    hydrate: Rn,
    createApp: Lc(Di, Rn)
  };
}
function gt({ effect: e, update: t }, r) {
  e.allowRecurse = t.allowRecurse = r;
}
function Kr(e, t, r = !1) {
  const n = e.children, o = t.children;
  if (R(n) && R(o))
    for (let i = 0; i < n.length; i++) {
      const s = n[i];
      let a = o[i];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = o[i] = ot(o[i]), a.el = s.el), r || Kr(s, a)), a.type === Mr && (a.el = s.el), process.env.NODE_ENV !== "production" && a.type === we && !a.el && (a.el = s.el);
    }
}
function tf(e) {
  const t = e.slice(), r = [0];
  let n, o, i, s, a;
  const l = e.length;
  for (n = 0; n < l; n++) {
    const u = e[n];
    if (u !== 0) {
      if (o = r[r.length - 1], e[o] < u) {
        t[n] = o, r.push(n);
        continue;
      }
      for (i = 0, s = r.length - 1; i < s; )
        a = i + s >> 1, e[r[a]] < u ? i = a + 1 : s = a;
      u < e[r[i]] && (i > 0 && (t[n] = r[i - 1]), r[i] = n);
    }
  }
  for (i = r.length, s = r[i - 1]; i-- > 0; )
    r[i] = s, s = t[s];
  return r;
}
const rf = (e) => e.__isTeleport, Le = Symbol.for("v-fgt"), Mr = Symbol.for("v-txt"), we = Symbol.for("v-cmt"), Yr = Symbol.for("v-stc"), hr = [];
let _e = null;
function Qe(e = !1) {
  hr.push(_e = e ? null : []);
}
function nf() {
  hr.pop(), _e = hr[hr.length - 1] || null;
}
let Or = 1;
function es(e) {
  Or += e;
}
function Xa(e) {
  return e.dynamicChildren = Or > 0 ? _e || Kt : null, nf(), Or > 0 && _e && _e.push(e), e;
}
function rt(e, t, r, n, o, i) {
  return Xa(
    T(
      e,
      t,
      r,
      n,
      o,
      i,
      !0
    )
  );
}
function of(e, t, r, n, o) {
  return Xa(
    $e(
      e,
      t,
      r,
      n,
      o,
      !0
    )
  );
}
function ci(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function ar(e, t) {
  return process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && Ut.has(t.type) ? (e.shapeFlag &= -257, t.shapeFlag &= -513, !1) : e.type === t.type && e.key === t.key;
}
const sf = (...e) => $a(
  ...e
), Dn = "__vInternal", Za = ({ key: e }) => e != null ? e : null, Qr = ({
  ref: e,
  ref_key: t,
  ref_for: r
}) => (typeof e == "number" && (e = "" + e), e != null ? ne(e) || se(e) || V(e) ? { i: De, r: e, k: t, f: !!r } : e : null);
function T(e, t = null, r = null, n = 0, o = null, i = e === Le ? 0 : 1, s = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && Za(t),
    ref: t && Qr(t),
    scopeId: wn,
    slotScopeIds: null,
    children: r,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: n,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: De
  };
  return a ? (fi(l, r), i & 128 && e.normalize(l)) : r && (l.shapeFlag |= ne(r) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && O("VNode created with invalid key (NaN). VNode type:", l.type), Or > 0 && !s && _e && (l.patchFlag > 0 || i & 6) && l.patchFlag !== 32 && _e.push(l), l;
}
const $e = process.env.NODE_ENV !== "production" ? sf : $a;
function $a(e, t = null, r = null, n = 0, o = null, i = !1) {
  if ((!e || e === Ic) && (process.env.NODE_ENV !== "production" && !e && O(`Invalid vnode type when creating vnode: ${e}.`), e = we), ci(e)) {
    const a = pt(
      e,
      t,
      !0
    );
    return r && fi(a, r), Or > 0 && !i && _e && (a.shapeFlag & 6 ? _e[_e.indexOf(e)] = a : _e.push(a)), a.patchFlag |= -2, a;
  }
  if (nl(e) && (e = e.__vccOpts), t) {
    t = af(t);
    let { class: a, style: l } = t;
    a && !ne(a) && (t.class = xe(a)), Z(l) && (Co(l) && !R(l) && (l = $({}, l)), t.style = gn(l));
  }
  const s = ne(e) ? 1 : dc(e) ? 128 : rf(e) ? 64 : Z(e) ? 4 : V(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && s & 4 && Co(e) && (e = B(e), O(
    "Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), T(
    e,
    t,
    r,
    n,
    o,
    s,
    i,
    !0
  );
}
function af(e) {
  return e ? Co(e) || Dn in e ? $({}, e) : e : null;
}
function pt(e, t, r = !1) {
  const { props: n, ref: o, patchFlag: i, children: s } = e, a = t ? lf(n || {}, t) : n;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: a,
    key: a && Za(a),
    ref: t && t.ref ? r && o ? R(o) ? o.concat(Qr(t)) : [o, Qr(t)] : Qr(t) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && i === -1 && R(s) ? s.map(Ga) : s,
    target: e.target,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    patchFlag: t && e.type !== Le ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: e.transition,
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && pt(e.ssContent),
    ssFallback: e.ssFallback && pt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
}
function Ga(e) {
  const t = pt(e);
  return R(e.children) && (t.children = e.children.map(Ga)), t;
}
function jo(e = " ", t = 0) {
  return $e(Mr, null, e, t);
}
function zn(e = "", t = !1) {
  return t ? (Qe(), of(we, null, e)) : $e(we, null, e);
}
function Se(e) {
  return e == null || typeof e == "boolean" ? $e(we) : R(e) ? $e(
    Le,
    null,
    e.slice()
  ) : typeof e == "object" ? ot(e) : $e(Mr, null, String(e));
}
function ot(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : pt(e);
}
function fi(e, t) {
  let r = 0;
  const { shapeFlag: n } = e;
  if (t == null)
    t = null;
  else if (R(t))
    r = 16;
  else if (typeof t == "object")
    if (n & 65) {
      const o = t.default;
      o && (o._c && (o._d = !1), fi(e, o()), o._c && (o._d = !0));
      return;
    } else {
      r = 32;
      const o = t._;
      !o && !(Dn in t) ? t._ctx = De : o === 3 && De && (De.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else
    V(t) ? (t = { default: t, _ctx: De }, r = 32) : (t = String(t), n & 64 ? (r = 16, t = [jo(t)]) : r = 8);
  e.children = t, e.shapeFlag |= r;
}
function lf(...e) {
  const t = {};
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    for (const o in n)
      if (o === "class")
        t.class !== n.class && (t.class = xe([t.class, n.class]));
      else if (o === "style")
        t.style = gn([t.style, n.style]);
      else if (Cr(o)) {
        const i = t[o], s = n[o];
        s && i !== s && !(R(i) && i.includes(s)) && (t[o] = i ? [].concat(i, s) : s);
      } else
        o !== "" && (t[o] = n[o]);
  }
  return t;
}
function Ve(e, t, r, n = null) {
  Te(e, t, 7, [
    r,
    n
  ]);
}
const uf = Ha();
let cf = 0;
function ff(e, t, r) {
  const n = e.type, o = (t ? t.appContext : e.appContext) || uf, i = {
    uid: cf++,
    vnode: e,
    type: n,
    parent: t,
    appContext: o,
    root: null,
    next: null,
    subTree: null,
    effect: null,
    update: null,
    scope: new Gl(
      !0
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(o.provides),
    accessCache: null,
    renderCache: [],
    components: null,
    directives: null,
    propsOptions: Wa(n, o),
    emitsOptions: Pa(n, o),
    emit: null,
    emitted: null,
    propsDefaults: X,
    inheritAttrs: n.inheritAttrs,
    ctx: X,
    data: X,
    props: X,
    attrs: X,
    slots: X,
    refs: X,
    setupState: X,
    setupContext: null,
    attrsProxy: null,
    slotsProxy: null,
    suspense: r,
    suspenseId: r ? r.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = xc(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = oc.bind(null, i), e.ce && e.ce(i), i;
}
let fe = null, pi, Bt, ts = "__VUE_INSTANCE_SETTERS__";
(Bt = en()[ts]) || (Bt = en()[ts] = []), Bt.push((e) => fe = e), pi = (e) => {
  Bt.length > 1 ? Bt.forEach((t) => t(e)) : Bt[0](e);
};
const Zt = (e) => {
  pi(e), e.scope.on();
}, Mt = () => {
  fe && fe.scope.off(), pi(null);
}, pf = /* @__PURE__ */ dt("slot,component");
function Vo(e, t) {
  const r = t.isNativeTag || ea;
  (pf(e) || r(e)) && O(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function el(e) {
  return e.vnode.shapeFlag & 4;
}
let wr = !1;
function df(e, t = !1) {
  wr = t;
  const { props: r, children: n } = e.vnode, o = el(e);
  zc(e, r, o, t), Xc(e, n);
  const i = o ? hf(e, t) : void 0;
  return wr = !1, i;
}
function hf(e, t) {
  var r;
  const n = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (n.name && Vo(n.name, e.appContext.config), n.components) {
      const i = Object.keys(n.components);
      for (let s = 0; s < i.length; s++)
        Vo(i[s], e.appContext.config);
    }
    if (n.directives) {
      const i = Object.keys(n.directives);
      for (let s = 0; s < i.length; s++)
        Fa(i[s]);
    }
    n.compilerOptions && mf() && O(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = Ea(new Proxy(e.ctx, za)), process.env.NODE_ENV !== "production" && Sc(e);
  const { setup: o } = n;
  if (o) {
    const i = e.setupContext = o.length > 1 ? yf(e) : null;
    Zt(e), _t();
    const s = Ze(
      o,
      e,
      0,
      [process.env.NODE_ENV !== "production" ? cr(e.props) : e.props, i]
    );
    if (Tt(), Mt(), Jo(s)) {
      if (s.then(Mt, Mt), t)
        return s.then((a) => {
          rs(e, a, t);
        }).catch((a) => {
          An(a, e, 0);
        });
      if (e.asyncDep = s, process.env.NODE_ENV !== "production" && !e.suspense) {
        const a = (r = n.name) != null ? r : "Anonymous";
        O(
          `Component <${a}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      rs(e, s, t);
  } else
    tl(e, t);
}
function rs(e, t, r) {
  V(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Z(t) ? (process.env.NODE_ENV !== "production" && ci(t) && O(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = Na(t), process.env.NODE_ENV !== "production" && _c(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && O(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), tl(e, r);
}
let Fo;
const mf = () => !Fo;
function tl(e, t, r) {
  const n = e.type;
  if (!e.render) {
    if (!t && Fo && !n.render) {
      const o = n.template || li(e).template;
      if (o) {
        process.env.NODE_ENV !== "production" && Ke(e, "compile");
        const { isCustomElement: i, compilerOptions: s } = e.appContext.config, { delimiters: a, compilerOptions: l } = n, u = $(
          $(
            {
              isCustomElement: i,
              delimiters: a
            },
            s
          ),
          l
        );
        n.render = Fo(o, u), process.env.NODE_ENV !== "production" && Ye(e, "compile");
      }
    }
    e.render = n.render || ce;
  }
  Zt(e), _t(), Pc(e), Tt(), Mt(), process.env.NODE_ENV !== "production" && !n.render && e.render === ce && !t && (n.template ? O(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : O("Component is missing template or render function."));
}
function ns(e) {
  return e.attrsProxy || (e.attrsProxy = new Proxy(
    e.attrs,
    process.env.NODE_ENV !== "production" ? {
      get(t, r) {
        return nn(), pe(e, "get", "$attrs"), t[r];
      },
      set() {
        return O("setupContext.attrs is readonly."), !1;
      },
      deleteProperty() {
        return O("setupContext.attrs is readonly."), !1;
      }
    } : {
      get(t, r) {
        return pe(e, "get", "$attrs"), t[r];
      }
    }
  ));
}
function gf(e) {
  return e.slotsProxy || (e.slotsProxy = new Proxy(e.slots, {
    get(t, r) {
      return pe(e, "get", "$slots"), t[r];
    }
  }));
}
function yf(e) {
  const t = (r) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && O("expose() should be called only once per setup()."), r != null)) {
      let n = typeof r;
      n === "object" && (R(r) ? n = "array" : se(r) && (n = "ref")), n !== "object" && O(
        `expose() should be passed a plain object, received ${n}.`
      );
    }
    e.exposed = r || {};
  };
  return process.env.NODE_ENV !== "production" ? Object.freeze({
    get attrs() {
      return ns(e);
    },
    get slots() {
      return gf(e);
    },
    get emit() {
      return (r, ...n) => e.emit(r, ...n);
    },
    expose: t
  }) : {
    get attrs() {
      return ns(e);
    },
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function di(e) {
  if (e.exposed)
    return e.exposeProxy || (e.exposeProxy = new Proxy(Na(Ea(e.exposed)), {
      get(t, r) {
        if (r in t)
          return t[r];
        if (r in Dt)
          return Dt[r](e);
      },
      has(t, r) {
        return r in t || r in Dt;
      }
    }));
}
const vf = /(?:^|[-_])(\w)/g, Ef = (e) => e.replace(vf, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function rl(e, t = !0) {
  return V(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Mn(e, t, r = !1) {
  let n = rl(t);
  if (!n && t.__file) {
    const o = t.__file.match(/([^/\\]+)\.\w+$/);
    o && (n = o[1]);
  }
  if (!n && e && e.parent) {
    const o = (i) => {
      for (const s in i)
        if (i[s] === t)
          return s;
    };
    n = o(
      e.components || e.parent.type.components
    ) || o(e.appContext.components);
  }
  return n ? Ef(n) : r ? "App" : "Anonymous";
}
function nl(e) {
  return V(e) && "__vccOpts" in e;
}
const Je = (e, t) => ju(e, t, wr), bf = Symbol.for("v-scx"), Af = () => {
  {
    const e = Wr(bf);
    return e || process.env.NODE_ENV !== "production" && O(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Un(e) {
  return !!(e && e.__v_isShallow);
}
function Nf() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#0b1bc9" }, r = { style: "color:#b62e24" }, n = { style: "color:#9d288c" }, o = {
    header(f) {
      return Z(f) ? f.__isVue ? ["div", e, "VueInstance"] : se(f) ? [
        "div",
        {},
        ["span", e, p(f)],
        "<",
        a(f.value),
        ">"
      ] : Ot(f) ? [
        "div",
        {},
        ["span", e, Un(f) ? "ShallowReactive" : "Reactive"],
        "<",
        a(f),
        `>${ft(f) ? " (readonly)" : ""}`
      ] : ft(f) ? [
        "div",
        {},
        ["span", e, Un(f) ? "ShallowReadonly" : "Readonly"],
        "<",
        a(f),
        ">"
      ] : null : null;
    },
    hasBody(f) {
      return f && f.__isVue;
    },
    body(f) {
      if (f && f.__isVue)
        return [
          "div",
          {},
          ...i(f.$)
        ];
    }
  };
  function i(f) {
    const h = [];
    f.type.props && f.props && h.push(s("props", B(f.props))), f.setupState !== X && h.push(s("setup", f.setupState)), f.data !== X && h.push(s("data", B(f.data)));
    const E = l(f, "computed");
    E && h.push(s("computed", E));
    const D = l(f, "inject");
    return D && h.push(s("injected", D)), h.push([
      "div",
      {},
      [
        "span",
        {
          style: n.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: f }]
    ]), h;
  }
  function s(f, h) {
    return h = $({}, h), Object.keys(h).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        f
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(h).map((E) => [
          "div",
          {},
          ["span", n, E + ": "],
          a(h[E], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(f, h = !0) {
    return typeof f == "number" ? ["span", t, f] : typeof f == "string" ? ["span", r, JSON.stringify(f)] : typeof f == "boolean" ? ["span", n, f] : Z(f) ? ["object", { object: h ? B(f) : f }] : ["span", r, String(f)];
  }
  function l(f, h) {
    const E = f.type;
    if (V(E))
      return;
    const D = {};
    for (const I in f.ctx)
      u(E, I, h) && (D[I] = f.ctx[I]);
    return D;
  }
  function u(f, h, E) {
    const D = f[E];
    if (R(D) && D.includes(h) || Z(D) && h in D || f.extends && u(f.extends, h, E) || f.mixins && f.mixins.some((I) => u(I, h, E)))
      return !0;
  }
  function p(f) {
    return Un(f) ? "ShallowRef" : f.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(o) : window.devtoolsFormatters = [o];
}
const os = "3.3.4", Of = "http://www.w3.org/2000/svg", Et = typeof document < "u" ? document : null, is = Et && /* @__PURE__ */ Et.createElement("template"), wf = {
  insert: (e, t, r) => {
    t.insertBefore(e, r || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, r, n) => {
    const o = t ? Et.createElementNS(Of, e) : Et.createElement(e, r ? { is: r } : void 0);
    return e === "select" && n && n.multiple != null && o.setAttribute("multiple", n.multiple), o;
  },
  createText: (e) => Et.createTextNode(e),
  createComment: (e) => Et.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Et.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  insertStaticContent(e, t, r, n, o, i) {
    const s = r ? r.previousSibling : t.lastChild;
    if (o && (o === i || o.nextSibling))
      for (; t.insertBefore(o.cloneNode(!0), r), !(o === i || !(o = o.nextSibling)); )
        ;
    else {
      is.innerHTML = n ? `<svg>${e}</svg>` : e;
      const a = is.content;
      if (n) {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, r);
    }
    return [
      s ? s.nextSibling : t.firstChild,
      r ? r.previousSibling : t.lastChild
    ];
  }
};
function Cf(e, t, r) {
  const n = e._vtc;
  n && (t = (t ? [t, ...n] : [...n]).join(" ")), t == null ? e.removeAttribute("class") : r ? e.setAttribute("class", t) : e.className = t;
}
function Df(e, t, r) {
  const n = e.style, o = ne(r);
  if (r && !o) {
    if (t && !ne(t))
      for (const i in t)
        r[i] == null && Bo(n, i, "");
    for (const i in r)
      Bo(n, i, r[i]);
  } else {
    const i = n.display;
    o ? t !== r && (n.cssText = r) : t && e.removeAttribute("style"), "_vod" in e && (n.display = i);
  }
}
const Mf = /[^\\];\s*$/, ss = /\s*!important$/;
function Bo(e, t, r) {
  if (R(r))
    r.forEach((n) => Bo(e, t, n));
  else if (r == null && (r = ""), process.env.NODE_ENV !== "production" && Mf.test(r) && O(
    `Unexpected semicolon at the end of '${t}' style value: '${r}'`
  ), t.startsWith("--"))
    e.setProperty(t, r);
  else {
    const n = If(e, t);
    ss.test(r) ? e.setProperty(
      ut(n),
      r.replace(ss, ""),
      "important"
    ) : e[n] = r;
  }
}
const as = ["Webkit", "Moz", "ms"], Hn = {};
function If(e, t) {
  const r = Hn[t];
  if (r)
    return r;
  let n = Xt(t);
  if (n !== "filter" && n in e)
    return Hn[t] = n;
  n = mn(n);
  for (let o = 0; o < as.length; o++) {
    const i = as[o] + n;
    if (i in e)
      return Hn[t] = i;
  }
  return t;
}
const ls = "http://www.w3.org/1999/xlink";
function xf(e, t, r, n, o) {
  if (n && t.startsWith("xlink:"))
    r == null ? e.removeAttributeNS(ls, t.slice(6, t.length)) : e.setAttributeNS(ls, t, r);
  else {
    const i = $l(t);
    r == null || i && !oa(r) ? e.removeAttribute(t) : e.setAttribute(t, i ? "" : r);
  }
}
function Sf(e, t, r, n, o, i, s) {
  if (t === "innerHTML" || t === "textContent") {
    n && s(n, o, i), e[t] = r == null ? "" : r;
    return;
  }
  const a = e.tagName;
  if (t === "value" && a !== "PROGRESS" && !a.includes("-")) {
    e._value = r;
    const u = a === "OPTION" ? e.getAttribute("value") : e.value, p = r == null ? "" : r;
    u !== p && (e.value = p), r == null && e.removeAttribute(t);
    return;
  }
  let l = !1;
  if (r === "" || r == null) {
    const u = typeof e[t];
    u === "boolean" ? r = oa(r) : r == null && u === "string" ? (r = "", l = !0) : u === "number" && (r = 0, l = !0);
  }
  try {
    e[t] = r;
  } catch (u) {
    process.env.NODE_ENV !== "production" && !l && O(
      `Failed setting prop "${t}" on <${a.toLowerCase()}>: value ${r} is invalid.`,
      u
    );
  }
  l && e.removeAttribute(t);
}
function _f(e, t, r, n) {
  e.addEventListener(t, r, n);
}
function Tf(e, t, r, n) {
  e.removeEventListener(t, r, n);
}
function Pf(e, t, r, n, o = null) {
  const i = e._vei || (e._vei = {}), s = i[t];
  if (n && s)
    s.value = n;
  else {
    const [a, l] = Rf(t);
    if (n) {
      const u = i[t] = Ff(n, o);
      _f(e, a, u, l);
    } else
      s && (Tf(e, a, s, l), i[t] = void 0);
  }
}
const us = /(?:Once|Passive|Capture)$/;
function Rf(e) {
  let t;
  if (us.test(e)) {
    t = {};
    let n;
    for (; n = e.match(us); )
      e = e.slice(0, e.length - n[0].length), t[n[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : ut(e.slice(2)), t];
}
let qn = 0;
const jf = /* @__PURE__ */ Promise.resolve(), Vf = () => qn || (jf.then(() => qn = 0), qn = Date.now());
function Ff(e, t) {
  const r = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= r.attached)
      return;
    Te(
      Bf(n, r.value),
      t,
      5,
      [n]
    );
  };
  return r.value = e, r.attached = Vf(), r;
}
function Bf(e, t) {
  if (R(t)) {
    const r = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      r.call(e), e._stopped = !0;
    }, t.map((n) => (o) => !o._stopped && n && n(o));
  } else
    return t;
}
const cs = /^on[a-z]/, Lf = (e, t, r, n, o = !1, i, s, a, l) => {
  t === "class" ? Cf(e, n, o) : t === "style" ? Df(e, r, n) : Cr(t) ? $r(t) || Pf(e, t, r, n, s) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : kf(e, t, n, o)) ? Sf(
    e,
    t,
    n,
    i,
    s,
    a,
    l
  ) : (t === "true-value" ? e._trueValue = n : t === "false-value" && (e._falseValue = n), xf(e, t, n, o));
};
function kf(e, t, r, n) {
  return n ? !!(t === "innerHTML" || t === "textContent" || t in e && cs.test(t) && V(r)) : t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA" || cs.test(t) && ne(r) ? !1 : t in e;
}
const zf = /* @__PURE__ */ $({ patchProp: Lf }, wf);
let fs;
function Uf() {
  return fs || (fs = Gc(zf));
}
const Hf = (...e) => {
  const t = Uf().createApp(...e);
  process.env.NODE_ENV !== "production" && (qf(t), Wf(t));
  const { mount: r } = t;
  return t.mount = (n) => {
    const o = Kf(n);
    if (!o)
      return;
    const i = t._component;
    !V(i) && !i.render && !i.template && (i.template = o.innerHTML), o.innerHTML = "";
    const s = r(o, !1, o instanceof SVGElement);
    return o instanceof Element && (o.removeAttribute("v-cloak"), o.setAttribute("data-v-app", "")), s;
  }, t;
};
function qf(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => Jl(t) || Xl(t),
    writable: !1
  });
}
function Wf(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        O(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const r = e.config.compilerOptions, n = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return O(n), r;
      },
      set() {
        O(n);
      }
    });
  }
}
function Kf(e) {
  if (ne(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && O(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && O(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
function Yf() {
  Nf();
}
process.env.NODE_ENV !== "production" && Yf();
window.reportMsgObj = {};
window.reportConfig = {
  errorTracker: !0,
  sample: 1,
  scrollTracker: !1,
  msgObjects: "reportMsgObj",
  supportH5: !0
};
const Fr = {
  sendCustomEvent(e, t = 1) {
    window.reportMsgObj[e] = t, window.performance && window.performance.mark && window.performance.mark(`reportMsgObj.${e}`);
  }
};
function Qf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Jf(e) {
  var t = e.default;
  if (typeof t == "function") {
    var r = function() {
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var ol = { exports: {} }, hi = { exports: {} }, il = function(t, r) {
  return function() {
    for (var o = new Array(arguments.length), i = 0; i < o.length; i++)
      o[i] = arguments[i];
    return t.apply(r, o);
  };
}, Xf = il, Pt = Object.prototype.toString;
function mi(e) {
  return Pt.call(e) === "[object Array]";
}
function Lo(e) {
  return typeof e > "u";
}
function Zf(e) {
  return e !== null && !Lo(e) && e.constructor !== null && !Lo(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function $f(e) {
  return Pt.call(e) === "[object ArrayBuffer]";
}
function Gf(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function ep(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && e.buffer instanceof ArrayBuffer, t;
}
function tp(e) {
  return typeof e == "string";
}
function rp(e) {
  return typeof e == "number";
}
function sl(e) {
  return e !== null && typeof e == "object";
}
function Jr(e) {
  if (Pt.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function np(e) {
  return Pt.call(e) === "[object Date]";
}
function op(e) {
  return Pt.call(e) === "[object File]";
}
function ip(e) {
  return Pt.call(e) === "[object Blob]";
}
function al(e) {
  return Pt.call(e) === "[object Function]";
}
function sp(e) {
  return sl(e) && al(e.pipe);
}
function ap(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function lp(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function up() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function gi(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), mi(e))
      for (var r = 0, n = e.length; r < n; r++)
        t.call(null, e[r], r, e);
    else
      for (var o in e)
        Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
}
function ko() {
  var e = {};
  function t(o, i) {
    Jr(e[i]) && Jr(o) ? e[i] = ko(e[i], o) : Jr(o) ? e[i] = ko({}, o) : mi(o) ? e[i] = o.slice() : e[i] = o;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    gi(arguments[r], t);
  return e;
}
function cp(e, t, r) {
  return gi(t, function(o, i) {
    r && typeof o == "function" ? e[i] = Xf(o, r) : e[i] = o;
  }), e;
}
function fp(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var Ce = {
  isArray: mi,
  isArrayBuffer: $f,
  isBuffer: Zf,
  isFormData: Gf,
  isArrayBufferView: ep,
  isString: tp,
  isNumber: rp,
  isObject: sl,
  isPlainObject: Jr,
  isUndefined: Lo,
  isDate: np,
  isFile: op,
  isBlob: ip,
  isFunction: al,
  isStream: sp,
  isURLSearchParams: ap,
  isStandardBrowserEnv: up,
  forEach: gi,
  merge: ko,
  extend: cp,
  trim: lp,
  stripBOM: fp
}, Lt = Ce;
function ps(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var ll = function(t, r, n) {
  if (!r)
    return t;
  var o;
  if (n)
    o = n(r);
  else if (Lt.isURLSearchParams(r))
    o = r.toString();
  else {
    var i = [];
    Lt.forEach(r, function(l, u) {
      l === null || typeof l > "u" || (Lt.isArray(l) ? u = u + "[]" : l = [l], Lt.forEach(l, function(f) {
        Lt.isDate(f) ? f = f.toISOString() : Lt.isObject(f) && (f = JSON.stringify(f)), i.push(ps(u) + "=" + ps(f));
      }));
    }), o = i.join("&");
  }
  if (o) {
    var s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return t;
}, pp = Ce;
function In() {
  this.handlers = [];
}
In.prototype.use = function(t, r, n) {
  return this.handlers.push({
    fulfilled: t,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
In.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
In.prototype.forEach = function(t) {
  pp.forEach(this.handlers, function(n) {
    n !== null && t(n);
  });
};
var dp = In, hp = Ce, mp = function(t, r) {
  hp.forEach(t, function(o, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (t[r] = o, delete t[i]);
  });
}, ul = function(t, r, n, o, i) {
  return t.config = r, n && (t.code = n), t.request = o, t.response = i, t.isAxiosError = !0, t.toJSON = function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, t;
}, Wn, ds;
function cl() {
  if (ds)
    return Wn;
  ds = 1;
  var e = ul;
  return Wn = function(r, n, o, i, s) {
    var a = new Error(r);
    return e(a, n, o, i, s);
  }, Wn;
}
var Kn, hs;
function gp() {
  if (hs)
    return Kn;
  hs = 1;
  var e = cl();
  return Kn = function(r, n, o) {
    var i = o.config.validateStatus;
    !o.status || !i || i(o.status) ? r(o) : n(e(
      "Request failed with status code " + o.status,
      o.config,
      null,
      o.request,
      o
    ));
  }, Kn;
}
var Yn, ms;
function yp() {
  if (ms)
    return Yn;
  ms = 1;
  var e = Ce;
  return Yn = e.isStandardBrowserEnv() ? function() {
    return {
      write: function(n, o, i, s, a, l) {
        var u = [];
        u.push(n + "=" + encodeURIComponent(o)), e.isNumber(i) && u.push("expires=" + new Date(i).toGMTString()), e.isString(s) && u.push("path=" + s), e.isString(a) && u.push("domain=" + a), l === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(n) {
        var o = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return o ? decodeURIComponent(o[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), Yn;
}
var Qn, gs;
function vp() {
  return gs || (gs = 1, Qn = function(t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  }), Qn;
}
var Jn, ys;
function Ep() {
  return ys || (ys = 1, Jn = function(t, r) {
    return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
  }), Jn;
}
var Xn, vs;
function bp() {
  if (vs)
    return Xn;
  vs = 1;
  var e = vp(), t = Ep();
  return Xn = function(n, o) {
    return n && !e(o) ? t(n, o) : o;
  }, Xn;
}
var Zn, Es;
function Ap() {
  if (Es)
    return Zn;
  Es = 1;
  var e = Ce, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Zn = function(n) {
    var o = {}, i, s, a;
    return n && e.forEach(n.split(`
`), function(u) {
      if (a = u.indexOf(":"), i = e.trim(u.substr(0, a)).toLowerCase(), s = e.trim(u.substr(a + 1)), i) {
        if (o[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? o[i] = (o[i] ? o[i] : []).concat([s]) : o[i] = o[i] ? o[i] + ", " + s : s;
      }
    }), o;
  }, Zn;
}
var $n, bs;
function Np() {
  if (bs)
    return $n;
  bs = 1;
  var e = Ce;
  return $n = e.isStandardBrowserEnv() ? function() {
    var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), o;
    function i(s) {
      var a = s;
      return r && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return o = i(window.location.href), function(a) {
      var l = e.isString(a) ? i(a) : a;
      return l.protocol === o.protocol && l.host === o.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), $n;
}
var Gn, As;
function xn() {
  if (As)
    return Gn;
  As = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Gn = e, Gn;
}
var eo, Ns;
function Os() {
  if (Ns)
    return eo;
  Ns = 1;
  var e = Ce, t = gp(), r = yp(), n = ll, o = bp(), i = Ap(), s = Np(), a = cl(), l = Sn(), u = xn();
  return eo = function(f) {
    return new Promise(function(E, D) {
      var I = f.data, L = f.headers, x = f.responseType, K;
      function j() {
        f.cancelToken && f.cancelToken.unsubscribe(K), f.signal && f.signal.removeEventListener("abort", K);
      }
      e.isFormData(I) && delete L["Content-Type"];
      var N = new XMLHttpRequest();
      if (f.auth) {
        var _ = f.auth.username || "", ae = f.auth.password ? unescape(encodeURIComponent(f.auth.password)) : "";
        L.Authorization = "Basic " + btoa(_ + ":" + ae);
      }
      var G = o(f.baseURL, f.url);
      N.open(f.method.toUpperCase(), n(G, f.params, f.paramsSerializer), !0), N.timeout = f.timeout;
      function oe() {
        if (!!N) {
          var Y = "getAllResponseHeaders" in N ? i(N.getAllResponseHeaders()) : null, te = !x || x === "text" || x === "json" ? N.responseText : N.response, W = {
            data: te,
            status: N.status,
            statusText: N.statusText,
            headers: Y,
            config: f,
            request: N
          };
          t(function(Ae) {
            E(Ae), j();
          }, function(Ae) {
            D(Ae), j();
          }, W), N = null;
        }
      }
      if ("onloadend" in N ? N.onloadend = oe : N.onreadystatechange = function() {
        !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(oe);
      }, N.onabort = function() {
        !N || (D(a("Request aborted", f, "ECONNABORTED", N)), N = null);
      }, N.onerror = function() {
        D(a("Network Error", f, null, N)), N = null;
      }, N.ontimeout = function() {
        var te = f.timeout ? "timeout of " + f.timeout + "ms exceeded" : "timeout exceeded", W = f.transitional || l.transitional;
        f.timeoutErrorMessage && (te = f.timeoutErrorMessage), D(a(
          te,
          f,
          W.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          N
        )), N = null;
      }, e.isStandardBrowserEnv()) {
        var ee = (f.withCredentials || s(G)) && f.xsrfCookieName ? r.read(f.xsrfCookieName) : void 0;
        ee && (L[f.xsrfHeaderName] = ee);
      }
      "setRequestHeader" in N && e.forEach(L, function(te, W) {
        typeof I > "u" && W.toLowerCase() === "content-type" ? delete L[W] : N.setRequestHeader(W, te);
      }), e.isUndefined(f.withCredentials) || (N.withCredentials = !!f.withCredentials), x && x !== "json" && (N.responseType = f.responseType), typeof f.onDownloadProgress == "function" && N.addEventListener("progress", f.onDownloadProgress), typeof f.onUploadProgress == "function" && N.upload && N.upload.addEventListener("progress", f.onUploadProgress), (f.cancelToken || f.signal) && (K = function(Y) {
        !N || (D(!Y || Y && Y.type ? new u("canceled") : Y), N.abort(), N = null);
      }, f.cancelToken && f.cancelToken.subscribe(K), f.signal && (f.signal.aborted ? K() : f.signal.addEventListener("abort", K))), I || (I = null), N.send(I);
    });
  }, eo;
}
var to, ws;
function Sn() {
  if (ws)
    return to;
  ws = 1;
  var e = Ce, t = mp, r = ul, n = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function o(l, u) {
    !e.isUndefined(l) && e.isUndefined(l["Content-Type"]) && (l["Content-Type"] = u);
  }
  function i() {
    var l;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (l = Os()), l;
  }
  function s(l, u, p) {
    if (e.isString(l))
      try {
        return (u || JSON.parse)(l), e.trim(l);
      } catch (f) {
        if (f.name !== "SyntaxError")
          throw f;
      }
    return (p || JSON.stringify)(l);
  }
  var a = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: i(),
    transformRequest: [function(u, p) {
      return t(p, "Accept"), t(p, "Content-Type"), e.isFormData(u) || e.isArrayBuffer(u) || e.isBuffer(u) || e.isStream(u) || e.isFile(u) || e.isBlob(u) ? u : e.isArrayBufferView(u) ? u.buffer : e.isURLSearchParams(u) ? (o(p, "application/x-www-form-urlencoded;charset=utf-8"), u.toString()) : e.isObject(u) || p && p["Content-Type"] === "application/json" ? (o(p, "application/json"), s(u)) : u;
    }],
    transformResponse: [function(u) {
      var p = this.transitional || a.transitional, f = p && p.silentJSONParsing, h = p && p.forcedJSONParsing, E = !f && this.responseType === "json";
      if (E || h && e.isString(u) && u.length)
        try {
          return JSON.parse(u);
        } catch (D) {
          if (E)
            throw D.name === "SyntaxError" ? r(D, this, "E_JSON_PARSE") : D;
        }
      return u;
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function(u) {
      return u >= 200 && u < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return e.forEach(["delete", "get", "head"], function(u) {
    a.headers[u] = {};
  }), e.forEach(["post", "put", "patch"], function(u) {
    a.headers[u] = e.merge(n);
  }), to = a, to;
}
var Op = Ce, wp = Sn(), Cp = function(t, r, n) {
  var o = this || wp;
  return Op.forEach(n, function(s) {
    t = s.call(o, t, r);
  }), t;
}, ro, Cs;
function fl() {
  return Cs || (Cs = 1, ro = function(t) {
    return !!(t && t.__CANCEL__);
  }), ro;
}
var Ds = Ce, no = Cp, Dp = fl(), Mp = Sn(), Ip = xn();
function oo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ip("canceled");
}
var xp = function(t) {
  oo(t), t.headers = t.headers || {}, t.data = no.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = Ds.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), Ds.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(o) {
      delete t.headers[o];
    }
  );
  var r = t.adapter || Mp.adapter;
  return r(t).then(function(o) {
    return oo(t), o.data = no.call(
      t,
      o.data,
      o.headers,
      t.transformResponse
    ), o;
  }, function(o) {
    return Dp(o) || (oo(t), o && o.response && (o.response.data = no.call(
      t,
      o.response.data,
      o.response.headers,
      t.transformResponse
    ))), Promise.reject(o);
  });
}, Oe = Ce, pl = function(t, r) {
  r = r || {};
  var n = {};
  function o(p, f) {
    return Oe.isPlainObject(p) && Oe.isPlainObject(f) ? Oe.merge(p, f) : Oe.isPlainObject(f) ? Oe.merge({}, f) : Oe.isArray(f) ? f.slice() : f;
  }
  function i(p) {
    if (Oe.isUndefined(r[p])) {
      if (!Oe.isUndefined(t[p]))
        return o(void 0, t[p]);
    } else
      return o(t[p], r[p]);
  }
  function s(p) {
    if (!Oe.isUndefined(r[p]))
      return o(void 0, r[p]);
  }
  function a(p) {
    if (Oe.isUndefined(r[p])) {
      if (!Oe.isUndefined(t[p]))
        return o(void 0, t[p]);
    } else
      return o(void 0, r[p]);
  }
  function l(p) {
    if (p in r)
      return o(t[p], r[p]);
    if (p in t)
      return o(void 0, t[p]);
  }
  var u = {
    url: s,
    method: s,
    data: s,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: l
  };
  return Oe.forEach(Object.keys(t).concat(Object.keys(r)), function(f) {
    var h = u[f] || i, E = h(f);
    Oe.isUndefined(E) && h !== l || (n[f] = E);
  }), n;
}, io, Ms;
function dl() {
  return Ms || (Ms = 1, io = {
    version: "0.24.0"
  }), io;
}
var Sp = dl().version, yi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  yi[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var Is = {};
yi.transitional = function(t, r, n) {
  function o(i, s) {
    return "[Axios v" + Sp + "] Transitional option '" + i + "'" + s + (n ? ". " + n : "");
  }
  return function(i, s, a) {
    if (t === !1)
      throw new Error(o(s, " has been removed" + (r ? " in " + r : "")));
    return r && !Is[s] && (Is[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, s, a) : !0;
  };
};
function _p(e, t, r) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(e), o = n.length; o-- > 0; ) {
    var i = n[o], s = t[i];
    if (s) {
      var a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new TypeError("option " + i + " must be " + l);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + i);
  }
}
var Tp = {
  assertOptions: _p,
  validators: yi
}, hl = Ce, Pp = ll, xs = dp, Ss = xp, _n = pl, ml = Tp, kt = ml.validators;
function Ir(e) {
  this.defaults = e, this.interceptors = {
    request: new xs(),
    response: new xs()
  };
}
Ir.prototype.request = function(t) {
  typeof t == "string" ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = _n(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var r = t.transitional;
  r !== void 0 && ml.assertOptions(r, {
    silentJSONParsing: kt.transitional(kt.boolean),
    forcedJSONParsing: kt.transitional(kt.boolean),
    clarifyTimeoutError: kt.transitional(kt.boolean)
  }, !1);
  var n = [], o = !0;
  this.interceptors.request.forEach(function(h) {
    typeof h.runWhen == "function" && h.runWhen(t) === !1 || (o = o && h.synchronous, n.unshift(h.fulfilled, h.rejected));
  });
  var i = [];
  this.interceptors.response.forEach(function(h) {
    i.push(h.fulfilled, h.rejected);
  });
  var s;
  if (!o) {
    var a = [Ss, void 0];
    for (Array.prototype.unshift.apply(a, n), a = a.concat(i), s = Promise.resolve(t); a.length; )
      s = s.then(a.shift(), a.shift());
    return s;
  }
  for (var l = t; n.length; ) {
    var u = n.shift(), p = n.shift();
    try {
      l = u(l);
    } catch (f) {
      p(f);
      break;
    }
  }
  try {
    s = Ss(l);
  } catch (f) {
    return Promise.reject(f);
  }
  for (; i.length; )
    s = s.then(i.shift(), i.shift());
  return s;
};
Ir.prototype.getUri = function(t) {
  return t = _n(this.defaults, t), Pp(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
hl.forEach(["delete", "get", "head", "options"], function(t) {
  Ir.prototype[t] = function(r, n) {
    return this.request(_n(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
hl.forEach(["post", "put", "patch"], function(t) {
  Ir.prototype[t] = function(r, n, o) {
    return this.request(_n(o || {}, {
      method: t,
      url: r,
      data: n
    }));
  };
});
var Rp = Ir, so, _s;
function jp() {
  if (_s)
    return so;
  _s = 1;
  var e = xn();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    var o = this;
    this.promise.then(function(i) {
      if (!!o._listeners) {
        var s, a = o._listeners.length;
        for (s = 0; s < a; s++)
          o._listeners[s](i);
        o._listeners = null;
      }
    }), this.promise.then = function(i) {
      var s, a = new Promise(function(l) {
        o.subscribe(l), s = l;
      }).then(i);
      return a.cancel = function() {
        o.unsubscribe(s);
      }, a;
    }, r(function(s) {
      o.reason || (o.reason = new e(s), n(o.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, t.prototype.unsubscribe = function(n) {
    if (!!this._listeners) {
      var o = this._listeners.indexOf(n);
      o !== -1 && this._listeners.splice(o, 1);
    }
  }, t.source = function() {
    var n, o = new t(function(s) {
      n = s;
    });
    return {
      token: o,
      cancel: n
    };
  }, so = t, so;
}
var ao, Ts;
function Vp() {
  return Ts || (Ts = 1, ao = function(t) {
    return function(n) {
      return t.apply(null, n);
    };
  }), ao;
}
var lo, Ps;
function Fp() {
  return Ps || (Ps = 1, lo = function(t) {
    return typeof t == "object" && t.isAxiosError === !0;
  }), lo;
}
var Rs = Ce, Bp = il, Xr = Rp, Lp = pl, kp = Sn();
function gl(e) {
  var t = new Xr(e), r = Bp(Xr.prototype.request, t);
  return Rs.extend(r, Xr.prototype, t), Rs.extend(r, t), r.create = function(o) {
    return gl(Lp(e, o));
  }, r;
}
var qe = gl(kp);
qe.Axios = Xr;
qe.Cancel = xn();
qe.CancelToken = jp();
qe.isCancel = fl();
qe.VERSION = dl().version;
qe.all = function(t) {
  return Promise.all(t);
};
qe.spread = Vp();
qe.isAxiosError = Fp();
hi.exports = qe;
hi.exports.default = qe;
(function(e) {
  e.exports = hi.exports;
})(ol);
const yl = /* @__PURE__ */ Qf(ol.exports);
var zp = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var o = 42;
  t[r] = o;
  for (r in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(t);
  if (i.length !== 1 || i[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var s = Object.getOwnPropertyDescriptor(t, r);
    if (s.value !== o || s.enumerable !== !0)
      return !1;
  }
  return !0;
}, js = typeof Symbol < "u" && Symbol, Up = zp, Hp = function() {
  return typeof js != "function" || typeof Symbol != "function" || typeof js("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Up();
}, Vs = {
  foo: {}
}, qp = Object, Wp = function() {
  return { __proto__: Vs }.foo === Vs.foo && !({ __proto__: null } instanceof qp);
}, Kp = "Function.prototype.bind called on incompatible ", uo = Array.prototype.slice, Yp = Object.prototype.toString, Qp = "[object Function]", Jp = function(t) {
  var r = this;
  if (typeof r != "function" || Yp.call(r) !== Qp)
    throw new TypeError(Kp + r);
  for (var n = uo.call(arguments, 1), o, i = function() {
    if (this instanceof o) {
      var p = r.apply(
        this,
        n.concat(uo.call(arguments))
      );
      return Object(p) === p ? p : this;
    } else
      return r.apply(
        t,
        n.concat(uo.call(arguments))
      );
  }, s = Math.max(0, r.length - n.length), a = [], l = 0; l < s; l++)
    a.push("$" + l);
  if (o = Function("binder", "return function (" + a.join(",") + "){ return binder.apply(this,arguments); }")(i), r.prototype) {
    var u = function() {
    };
    u.prototype = r.prototype, o.prototype = new u(), u.prototype = null;
  }
  return o;
}, Xp = Jp, vi = Function.prototype.bind || Xp, Zp = vi, $p = Zp.call(Function.call, Object.prototype.hasOwnProperty), U, $t = SyntaxError, vl = Function, Qt = TypeError, co = function(e) {
  try {
    return vl('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, It = Object.getOwnPropertyDescriptor;
if (It)
  try {
    It({}, "");
  } catch {
    It = null;
  }
var fo = function() {
  throw new Qt();
}, Gp = It ? function() {
  try {
    return arguments.callee, fo;
  } catch {
    try {
      return It(arguments, "callee").get;
    } catch {
      return fo;
    }
  }
}() : fo, zt = Hp(), ed = Wp(), ue = Object.getPrototypeOf || (ed ? function(e) {
  return e.__proto__;
} : null), Ht = {}, td = typeof Uint8Array > "u" || !ue ? U : ue(Uint8Array), xt = {
  "%AggregateError%": typeof AggregateError > "u" ? U : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? U : ArrayBuffer,
  "%ArrayIteratorPrototype%": zt && ue ? ue([][Symbol.iterator]()) : U,
  "%AsyncFromSyncIteratorPrototype%": U,
  "%AsyncFunction%": Ht,
  "%AsyncGenerator%": Ht,
  "%AsyncGeneratorFunction%": Ht,
  "%AsyncIteratorPrototype%": Ht,
  "%Atomics%": typeof Atomics > "u" ? U : Atomics,
  "%BigInt%": typeof BigInt > "u" ? U : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? U : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? U : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? U : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? U : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? U : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? U : FinalizationRegistry,
  "%Function%": vl,
  "%GeneratorFunction%": Ht,
  "%Int8Array%": typeof Int8Array > "u" ? U : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? U : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? U : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": zt && ue ? ue(ue([][Symbol.iterator]())) : U,
  "%JSON%": typeof JSON == "object" ? JSON : U,
  "%Map%": typeof Map > "u" ? U : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !zt || !ue ? U : ue((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? U : Promise,
  "%Proxy%": typeof Proxy > "u" ? U : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? U : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? U : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !zt || !ue ? U : ue((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? U : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": zt && ue ? ue(""[Symbol.iterator]()) : U,
  "%Symbol%": zt ? Symbol : U,
  "%SyntaxError%": $t,
  "%ThrowTypeError%": Gp,
  "%TypedArray%": td,
  "%TypeError%": Qt,
  "%Uint8Array%": typeof Uint8Array > "u" ? U : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? U : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? U : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? U : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? U : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? U : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? U : WeakSet
};
if (ue)
  try {
    null.error;
  } catch (e) {
    var rd = ue(ue(e));
    xt["%Error.prototype%"] = rd;
  }
var nd = function e(t) {
  var r;
  if (t === "%AsyncFunction%")
    r = co("async function () {}");
  else if (t === "%GeneratorFunction%")
    r = co("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    r = co("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = e("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var o = e("%AsyncGenerator%");
    o && ue && (r = ue(o.prototype));
  }
  return xt[t] = r, r;
}, Fs = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, xr = vi, ln = $p, od = xr.call(Function.call, Array.prototype.concat), id = xr.call(Function.apply, Array.prototype.splice), Bs = xr.call(Function.call, String.prototype.replace), un = xr.call(Function.call, String.prototype.slice), sd = xr.call(Function.call, RegExp.prototype.exec), ad = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ld = /\\(\\)?/g, ud = function(t) {
  var r = un(t, 0, 1), n = un(t, -1);
  if (r === "%" && n !== "%")
    throw new $t("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new $t("invalid intrinsic syntax, expected opening `%`");
  var o = [];
  return Bs(t, ad, function(i, s, a, l) {
    o[o.length] = a ? Bs(l, ld, "$1") : s || i;
  }), o;
}, cd = function(t, r) {
  var n = t, o;
  if (ln(Fs, n) && (o = Fs[n], n = "%" + o[0] + "%"), ln(xt, n)) {
    var i = xt[n];
    if (i === Ht && (i = nd(n)), typeof i > "u" && !r)
      throw new Qt("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: o,
      name: n,
      value: i
    };
  }
  throw new $t("intrinsic " + t + " does not exist!");
}, Ei = function(t, r) {
  if (typeof t != "string" || t.length === 0)
    throw new Qt("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Qt('"allowMissing" argument must be a boolean');
  if (sd(/^%?[^%]*%?$/, t) === null)
    throw new $t("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = ud(t), o = n.length > 0 ? n[0] : "", i = cd("%" + o + "%", r), s = i.name, a = i.value, l = !1, u = i.alias;
  u && (o = u[0], id(n, od([0, 1], u)));
  for (var p = 1, f = !0; p < n.length; p += 1) {
    var h = n[p], E = un(h, 0, 1), D = un(h, -1);
    if ((E === '"' || E === "'" || E === "`" || D === '"' || D === "'" || D === "`") && E !== D)
      throw new $t("property names with quotes must have matching quotes");
    if ((h === "constructor" || !f) && (l = !0), o += "." + h, s = "%" + o + "%", ln(xt, s))
      a = xt[s];
    else if (a != null) {
      if (!(h in a)) {
        if (!r)
          throw new Qt("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (It && p + 1 >= n.length) {
        var I = It(a, h);
        f = !!I, f && "get" in I && !("originalValue" in I.get) ? a = I.get : a = a[h];
      } else
        f = ln(a, h), a = a[h];
      f && !l && (xt[s] = a);
    }
  }
  return a;
}, El = { exports: {} };
(function(e) {
  var t = vi, r = Ei, n = r("%Function.prototype.apply%"), o = r("%Function.prototype.call%"), i = r("%Reflect.apply%", !0) || t.call(o, n), s = r("%Object.getOwnPropertyDescriptor%", !0), a = r("%Object.defineProperty%", !0), l = r("%Math.max%");
  if (a)
    try {
      a({}, "a", { value: 1 });
    } catch {
      a = null;
    }
  e.exports = function(f) {
    var h = i(t, o, arguments);
    if (s && a) {
      var E = s(h, "length");
      E.configurable && a(
        h,
        "length",
        { value: 1 + l(0, f.length - (arguments.length - 1)) }
      );
    }
    return h;
  };
  var u = function() {
    return i(t, n, arguments);
  };
  a ? a(e.exports, "apply", { value: u }) : e.exports.apply = u;
})(El);
var bl = Ei, Al = El.exports, fd = Al(bl("String.prototype.indexOf")), pd = function(t, r) {
  var n = bl(t, !!r);
  return typeof n == "function" && fd(t, ".prototype.") > -1 ? Al(n) : n;
};
const dd = {}, hd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dd
}, Symbol.toStringTag, { value: "Module" })), md = /* @__PURE__ */ Jf(hd);
var bi = typeof Map == "function" && Map.prototype, po = Object.getOwnPropertyDescriptor && bi ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, cn = bi && po && typeof po.get == "function" ? po.get : null, Ls = bi && Map.prototype.forEach, Ai = typeof Set == "function" && Set.prototype, ho = Object.getOwnPropertyDescriptor && Ai ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, fn = Ai && ho && typeof ho.get == "function" ? ho.get : null, ks = Ai && Set.prototype.forEach, gd = typeof WeakMap == "function" && WeakMap.prototype, mr = gd ? WeakMap.prototype.has : null, yd = typeof WeakSet == "function" && WeakSet.prototype, gr = yd ? WeakSet.prototype.has : null, vd = typeof WeakRef == "function" && WeakRef.prototype, zs = vd ? WeakRef.prototype.deref : null, Ed = Boolean.prototype.valueOf, bd = Object.prototype.toString, Ad = Function.prototype.toString, Nd = String.prototype.match, Ni = String.prototype.slice, at = String.prototype.replace, Od = String.prototype.toUpperCase, Us = String.prototype.toLowerCase, Nl = RegExp.prototype.test, Hs = Array.prototype.concat, ke = Array.prototype.join, wd = Array.prototype.slice, qs = Math.floor, zo = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, mo = Object.getOwnPropertySymbols, Uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Gt = typeof Symbol == "function" && typeof Symbol.iterator == "object", ge = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Gt ? "object" : "symbol") ? Symbol.toStringTag : null, Ol = Object.prototype.propertyIsEnumerable, Ws = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function Ks(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || Nl.call(/e/, t))
    return t;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var n = e < 0 ? -qs(-e) : qs(e);
    if (n !== e) {
      var o = String(n), i = Ni.call(t, o.length + 1);
      return at.call(o, r, "$&_") + "." + at.call(at.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return at.call(t, r, "$&_");
}
var Ho = md, Ys = Ho.custom, Qs = Cl(Ys) ? Ys : null, Cd = function e(t, r, n, o) {
  var i = r || {};
  if (it(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (it(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var s = it(i, "customInspect") ? i.customInspect : !0;
  if (typeof s != "boolean" && s !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (it(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (it(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var a = i.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Ml(t, i);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var l = String(t);
    return a ? Ks(t, l) : l;
  }
  if (typeof t == "bigint") {
    var u = String(t) + "n";
    return a ? Ks(t, u) : u;
  }
  var p = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof n > "u" && (n = 0), n >= p && p > 0 && typeof t == "object")
    return qo(t) ? "[Array]" : "[Object]";
  var f = Hd(i, n);
  if (typeof o > "u")
    o = [];
  else if (Dl(o, t) >= 0)
    return "[Circular]";
  function h(de, Ae, Ne) {
    if (Ae && (o = wd.call(o), o.push(Ae)), Ne) {
      var re = {
        depth: i.depth
      };
      return it(i, "quoteStyle") && (re.quoteStyle = i.quoteStyle), e(de, re, n + 1, o);
    }
    return e(de, i, n + 1, o);
  }
  if (typeof t == "function" && !Js(t)) {
    var E = Rd(t), D = Br(t, h);
    return "[Function" + (E ? ": " + E : " (anonymous)") + "]" + (D.length > 0 ? " { " + ke.call(D, ", ") + " }" : "");
  }
  if (Cl(t)) {
    var I = Gt ? at.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : Uo.call(t);
    return typeof t == "object" && !Gt ? lr(I) : I;
  }
  if (kd(t)) {
    for (var L = "<" + Us.call(String(t.nodeName)), x = t.attributes || [], K = 0; K < x.length; K++)
      L += " " + x[K].name + "=" + wl(Dd(x[K].value), "double", i);
    return L += ">", t.childNodes && t.childNodes.length && (L += "..."), L += "</" + Us.call(String(t.nodeName)) + ">", L;
  }
  if (qo(t)) {
    if (t.length === 0)
      return "[]";
    var j = Br(t, h);
    return f && !Ud(j) ? "[" + Wo(j, f) + "]" : "[ " + ke.call(j, ", ") + " ]";
  }
  if (Id(t)) {
    var N = Br(t, h);
    return !("cause" in Error.prototype) && "cause" in t && !Ol.call(t, "cause") ? "{ [" + String(t) + "] " + ke.call(Hs.call("[cause]: " + h(t.cause), N), ", ") + " }" : N.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + ke.call(N, ", ") + " }";
  }
  if (typeof t == "object" && s) {
    if (Qs && typeof t[Qs] == "function" && Ho)
      return Ho(t, { depth: p - n });
    if (s !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (jd(t)) {
    var _ = [];
    return Ls && Ls.call(t, function(de, Ae) {
      _.push(h(Ae, t, !0) + " => " + h(de, t));
    }), Xs("Map", cn.call(t), _, f);
  }
  if (Bd(t)) {
    var ae = [];
    return ks && ks.call(t, function(de) {
      ae.push(h(de, t));
    }), Xs("Set", fn.call(t), ae, f);
  }
  if (Vd(t))
    return go("WeakMap");
  if (Ld(t))
    return go("WeakSet");
  if (Fd(t))
    return go("WeakRef");
  if (Sd(t))
    return lr(h(Number(t)));
  if (Td(t))
    return lr(h(zo.call(t)));
  if (_d(t))
    return lr(Ed.call(t));
  if (xd(t))
    return lr(h(String(t)));
  if (!Md(t) && !Js(t)) {
    var G = Br(t, h), oe = Ws ? Ws(t) === Object.prototype : t instanceof Object || t.constructor === Object, ee = t instanceof Object ? "" : "null prototype", Y = !oe && ge && Object(t) === t && ge in t ? Ni.call(ht(t), 8, -1) : ee ? "Object" : "", te = oe || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", W = te + (Y || ee ? "[" + ke.call(Hs.call([], Y || [], ee || []), ": ") + "] " : "");
    return G.length === 0 ? W + "{}" : f ? W + "{" + Wo(G, f) + "}" : W + "{ " + ke.call(G, ", ") + " }";
  }
  return String(t);
};
function wl(e, t, r) {
  var n = (r.quoteStyle || t) === "double" ? '"' : "'";
  return n + e + n;
}
function Dd(e) {
  return at.call(String(e), /"/g, "&quot;");
}
function qo(e) {
  return ht(e) === "[object Array]" && (!ge || !(typeof e == "object" && ge in e));
}
function Md(e) {
  return ht(e) === "[object Date]" && (!ge || !(typeof e == "object" && ge in e));
}
function Js(e) {
  return ht(e) === "[object RegExp]" && (!ge || !(typeof e == "object" && ge in e));
}
function Id(e) {
  return ht(e) === "[object Error]" && (!ge || !(typeof e == "object" && ge in e));
}
function xd(e) {
  return ht(e) === "[object String]" && (!ge || !(typeof e == "object" && ge in e));
}
function Sd(e) {
  return ht(e) === "[object Number]" && (!ge || !(typeof e == "object" && ge in e));
}
function _d(e) {
  return ht(e) === "[object Boolean]" && (!ge || !(typeof e == "object" && ge in e));
}
function Cl(e) {
  if (Gt)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !Uo)
    return !1;
  try {
    return Uo.call(e), !0;
  } catch {
  }
  return !1;
}
function Td(e) {
  if (!e || typeof e != "object" || !zo)
    return !1;
  try {
    return zo.call(e), !0;
  } catch {
  }
  return !1;
}
var Pd = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function it(e, t) {
  return Pd.call(e, t);
}
function ht(e) {
  return bd.call(e);
}
function Rd(e) {
  if (e.name)
    return e.name;
  var t = Nd.call(Ad.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Dl(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var r = 0, n = e.length; r < n; r++)
    if (e[r] === t)
      return r;
  return -1;
}
function jd(e) {
  if (!cn || !e || typeof e != "object")
    return !1;
  try {
    cn.call(e);
    try {
      fn.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function Vd(e) {
  if (!mr || !e || typeof e != "object")
    return !1;
  try {
    mr.call(e, mr);
    try {
      gr.call(e, gr);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Fd(e) {
  if (!zs || !e || typeof e != "object")
    return !1;
  try {
    return zs.call(e), !0;
  } catch {
  }
  return !1;
}
function Bd(e) {
  if (!fn || !e || typeof e != "object")
    return !1;
  try {
    fn.call(e);
    try {
      cn.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function Ld(e) {
  if (!gr || !e || typeof e != "object")
    return !1;
  try {
    gr.call(e, gr);
    try {
      mr.call(e, mr);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function kd(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Ml(e, t) {
  if (e.length > t.maxStringLength) {
    var r = e.length - t.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Ml(Ni.call(e, 0, t.maxStringLength), t) + n;
  }
  var o = at.call(at.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, zd);
  return wl(o, "single", t);
}
function zd(e) {
  var t = e.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + Od.call(t.toString(16));
}
function lr(e) {
  return "Object(" + e + ")";
}
function go(e) {
  return e + " { ? }";
}
function Xs(e, t, r, n) {
  var o = n ? Wo(r, n) : ke.call(r, ", ");
  return e + " (" + t + ") {" + o + "}";
}
function Ud(e) {
  for (var t = 0; t < e.length; t++)
    if (Dl(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function Hd(e, t) {
  var r;
  if (e.indent === "	")
    r = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    r = ke.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: ke.call(Array(t + 1), r)
  };
}
function Wo(e, t) {
  if (e.length === 0)
    return "";
  var r = `
` + t.prev + t.base;
  return r + ke.call(e, "," + r) + `
` + t.prev;
}
function Br(e, t) {
  var r = qo(e), n = [];
  if (r) {
    n.length = e.length;
    for (var o = 0; o < e.length; o++)
      n[o] = it(e, o) ? t(e[o], e) : "";
  }
  var i = typeof mo == "function" ? mo(e) : [], s;
  if (Gt) {
    s = {};
    for (var a = 0; a < i.length; a++)
      s["$" + i[a]] = i[a];
  }
  for (var l in e)
    !it(e, l) || r && String(Number(l)) === l && l < e.length || Gt && s["$" + l] instanceof Symbol || (Nl.call(/[^\w$]/, l) ? n.push(t(l, e) + ": " + t(e[l], e)) : n.push(l + ": " + t(e[l], e)));
  if (typeof mo == "function")
    for (var u = 0; u < i.length; u++)
      Ol.call(e, i[u]) && n.push("[" + t(i[u]) + "]: " + t(e[i[u]], e));
  return n;
}
var Oi = Ei, tr = pd, qd = Cd, Wd = Oi("%TypeError%"), Lr = Oi("%WeakMap%", !0), kr = Oi("%Map%", !0), Kd = tr("WeakMap.prototype.get", !0), Yd = tr("WeakMap.prototype.set", !0), Qd = tr("WeakMap.prototype.has", !0), Jd = tr("Map.prototype.get", !0), Xd = tr("Map.prototype.set", !0), Zd = tr("Map.prototype.has", !0), wi = function(e, t) {
  for (var r = e, n; (n = r.next) !== null; r = n)
    if (n.key === t)
      return r.next = n.next, n.next = e.next, e.next = n, n;
}, $d = function(e, t) {
  var r = wi(e, t);
  return r && r.value;
}, Gd = function(e, t, r) {
  var n = wi(e, t);
  n ? n.value = r : e.next = {
    key: t,
    next: e.next,
    value: r
  };
}, eh = function(e, t) {
  return !!wi(e, t);
}, th = function() {
  var t, r, n, o = {
    assert: function(i) {
      if (!o.has(i))
        throw new Wd("Side channel does not contain " + qd(i));
    },
    get: function(i) {
      if (Lr && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return Kd(t, i);
      } else if (kr) {
        if (r)
          return Jd(r, i);
      } else if (n)
        return $d(n, i);
    },
    has: function(i) {
      if (Lr && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return Qd(t, i);
      } else if (kr) {
        if (r)
          return Zd(r, i);
      } else if (n)
        return eh(n, i);
      return !1;
    },
    set: function(i, s) {
      Lr && i && (typeof i == "object" || typeof i == "function") ? (t || (t = new Lr()), Yd(t, i, s)) : kr ? (r || (r = new kr()), Xd(r, i, s)) : (n || (n = { key: {}, next: null }), Gd(n, i, s));
    }
  };
  return o;
}, rh = String.prototype.replace, nh = /%20/g, yo = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ci = {
  default: yo.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return rh.call(e, nh, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: yo.RFC1738,
  RFC3986: yo.RFC3986
}, oh = Ci, vo = Object.prototype.hasOwnProperty, bt = Array.isArray, Fe = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), ih = function(t) {
  for (; t.length > 1; ) {
    var r = t.pop(), n = r.obj[r.prop];
    if (bt(n)) {
      for (var o = [], i = 0; i < n.length; ++i)
        typeof n[i] < "u" && o.push(n[i]);
      r.obj[r.prop] = o;
    }
  }
}, Il = function(t, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = 0; o < t.length; ++o)
    typeof t[o] < "u" && (n[o] = t[o]);
  return n;
}, sh = function e(t, r, n) {
  if (!r)
    return t;
  if (typeof r != "object") {
    if (bt(t))
      t.push(r);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !vo.call(Object.prototype, r)) && (t[r] = !0);
    else
      return [t, r];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(r);
  var o = t;
  return bt(t) && !bt(r) && (o = Il(t, n)), bt(t) && bt(r) ? (r.forEach(function(i, s) {
    if (vo.call(t, s)) {
      var a = t[s];
      a && typeof a == "object" && i && typeof i == "object" ? t[s] = e(a, i, n) : t.push(i);
    } else
      t[s] = i;
  }), t) : Object.keys(r).reduce(function(i, s) {
    var a = r[s];
    return vo.call(i, s) ? i[s] = e(i[s], a, n) : i[s] = a, i;
  }, o);
}, ah = function(t, r) {
  return Object.keys(r).reduce(function(n, o) {
    return n[o] = r[o], n;
  }, t);
}, lh = function(e, t, r) {
  var n = e.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, uh = function(t, r, n, o, i) {
  if (t.length === 0)
    return t;
  var s = t;
  if (typeof t == "symbol" ? s = Symbol.prototype.toString.call(t) : typeof t != "string" && (s = String(t)), n === "iso-8859-1")
    return escape(s).replace(/%u[0-9a-f]{4}/gi, function(p) {
      return "%26%23" + parseInt(p.slice(2), 16) + "%3B";
    });
  for (var a = "", l = 0; l < s.length; ++l) {
    var u = s.charCodeAt(l);
    if (u === 45 || u === 46 || u === 95 || u === 126 || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || i === oh.RFC1738 && (u === 40 || u === 41)) {
      a += s.charAt(l);
      continue;
    }
    if (u < 128) {
      a = a + Fe[u];
      continue;
    }
    if (u < 2048) {
      a = a + (Fe[192 | u >> 6] + Fe[128 | u & 63]);
      continue;
    }
    if (u < 55296 || u >= 57344) {
      a = a + (Fe[224 | u >> 12] + Fe[128 | u >> 6 & 63] + Fe[128 | u & 63]);
      continue;
    }
    l += 1, u = 65536 + ((u & 1023) << 10 | s.charCodeAt(l) & 1023), a += Fe[240 | u >> 18] + Fe[128 | u >> 12 & 63] + Fe[128 | u >> 6 & 63] + Fe[128 | u & 63];
  }
  return a;
}, ch = function(t) {
  for (var r = [{ obj: { o: t }, prop: "o" }], n = [], o = 0; o < r.length; ++o)
    for (var i = r[o], s = i.obj[i.prop], a = Object.keys(s), l = 0; l < a.length; ++l) {
      var u = a[l], p = s[u];
      typeof p == "object" && p !== null && n.indexOf(p) === -1 && (r.push({ obj: s, prop: u }), n.push(p));
    }
  return ih(r), t;
}, fh = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, ph = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, dh = function(t, r) {
  return [].concat(t, r);
}, hh = function(t, r) {
  if (bt(t)) {
    for (var n = [], o = 0; o < t.length; o += 1)
      n.push(r(t[o]));
    return n;
  }
  return r(t);
}, xl = {
  arrayToObject: Il,
  assign: ah,
  combine: dh,
  compact: ch,
  decode: lh,
  encode: uh,
  isBuffer: ph,
  isRegExp: fh,
  maybeMap: hh,
  merge: sh
}, Sl = th, Zr = xl, yr = Ci, mh = Object.prototype.hasOwnProperty, Zs = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, r) {
    return t + "[" + r + "]";
  },
  repeat: function(t) {
    return t;
  }
}, Xe = Array.isArray, gh = Array.prototype.push, _l = function(e, t) {
  gh.apply(e, Xe(t) ? t : [t]);
}, yh = Date.prototype.toISOString, $s = yr.default, he = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: Zr.encode,
  encodeValuesOnly: !1,
  format: $s,
  formatter: yr.formatters[$s],
  indices: !1,
  serializeDate: function(t) {
    return yh.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, vh = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, Eo = {}, Eh = function e(t, r, n, o, i, s, a, l, u, p, f, h, E, D, I, L) {
  for (var x = t, K = L, j = 0, N = !1; (K = K.get(Eo)) !== void 0 && !N; ) {
    var _ = K.get(t);
    if (j += 1, typeof _ < "u") {
      if (_ === j)
        throw new RangeError("Cyclic object value");
      N = !0;
    }
    typeof K.get(Eo) > "u" && (j = 0);
  }
  if (typeof l == "function" ? x = l(r, x) : x instanceof Date ? x = f(x) : n === "comma" && Xe(x) && (x = Zr.maybeMap(x, function(re) {
    return re instanceof Date ? f(re) : re;
  })), x === null) {
    if (i)
      return a && !D ? a(r, he.encoder, I, "key", h) : r;
    x = "";
  }
  if (vh(x) || Zr.isBuffer(x)) {
    if (a) {
      var ae = D ? r : a(r, he.encoder, I, "key", h);
      return [E(ae) + "=" + E(a(x, he.encoder, I, "value", h))];
    }
    return [E(r) + "=" + E(String(x))];
  }
  var G = [];
  if (typeof x > "u")
    return G;
  var oe;
  if (n === "comma" && Xe(x))
    D && a && (x = Zr.maybeMap(x, a)), oe = [{ value: x.length > 0 ? x.join(",") || null : void 0 }];
  else if (Xe(l))
    oe = l;
  else {
    var ee = Object.keys(x);
    oe = u ? ee.sort(u) : ee;
  }
  for (var Y = o && Xe(x) && x.length === 1 ? r + "[]" : r, te = 0; te < oe.length; ++te) {
    var W = oe[te], de = typeof W == "object" && typeof W.value < "u" ? W.value : x[W];
    if (!(s && de === null)) {
      var Ae = Xe(x) ? typeof n == "function" ? n(Y, W) : Y : Y + (p ? "." + W : "[" + W + "]");
      L.set(t, j);
      var Ne = Sl();
      Ne.set(Eo, L), _l(G, e(
        de,
        Ae,
        n,
        o,
        i,
        s,
        n === "comma" && D && Xe(x) ? null : a,
        l,
        u,
        p,
        f,
        h,
        E,
        D,
        I,
        Ne
      ));
    }
  }
  return G;
}, bh = function(t) {
  if (!t)
    return he;
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = t.charset || he.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = yr.default;
  if (typeof t.format < "u") {
    if (!mh.call(yr.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var o = yr.formatters[n], i = he.filter;
  return (typeof t.filter == "function" || Xe(t.filter)) && (i = t.filter), {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : he.addQueryPrefix,
    allowDots: typeof t.allowDots > "u" ? he.allowDots : !!t.allowDots,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : he.charsetSentinel,
    delimiter: typeof t.delimiter > "u" ? he.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : he.encode,
    encoder: typeof t.encoder == "function" ? t.encoder : he.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : he.encodeValuesOnly,
    filter: i,
    format: n,
    formatter: o,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : he.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : he.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : he.strictNullHandling
  };
}, Ah = function(e, t) {
  var r = e, n = bh(t), o, i;
  typeof n.filter == "function" ? (i = n.filter, r = i("", r)) : Xe(n.filter) && (i = n.filter, o = i);
  var s = [];
  if (typeof r != "object" || r === null)
    return "";
  var a;
  t && t.arrayFormat in Zs ? a = t.arrayFormat : t && "indices" in t ? a = t.indices ? "indices" : "repeat" : a = "indices";
  var l = Zs[a];
  if (t && "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var u = l === "comma" && t && t.commaRoundTrip;
  o || (o = Object.keys(r)), n.sort && o.sort(n.sort);
  for (var p = Sl(), f = 0; f < o.length; ++f) {
    var h = o[f];
    n.skipNulls && r[h] === null || _l(s, Eh(
      r[h],
      h,
      l,
      u,
      n.strictNullHandling,
      n.skipNulls,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      p
    ));
  }
  var E = s.join(n.delimiter), D = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? D += "utf8=%26%2310003%3B&" : D += "utf8=%E2%9C%93&"), E.length > 0 ? D + E : "";
}, er = xl, Ko = Object.prototype.hasOwnProperty, Nh = Array.isArray, le = {
  allowDots: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: er.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, Oh = function(e) {
  return e.replace(/&#(\d+);/g, function(t, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, Tl = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, wh = "utf8=%26%2310003%3B", Ch = "utf8=%E2%9C%93", Dh = function(t, r) {
  var n = { __proto__: null }, o = r.ignoreQueryPrefix ? t.replace(/^\?/, "") : t, i = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, s = o.split(r.delimiter, i), a = -1, l, u = r.charset;
  if (r.charsetSentinel)
    for (l = 0; l < s.length; ++l)
      s[l].indexOf("utf8=") === 0 && (s[l] === Ch ? u = "utf-8" : s[l] === wh && (u = "iso-8859-1"), a = l, l = s.length);
  for (l = 0; l < s.length; ++l)
    if (l !== a) {
      var p = s[l], f = p.indexOf("]="), h = f === -1 ? p.indexOf("=") : f + 1, E, D;
      h === -1 ? (E = r.decoder(p, le.decoder, u, "key"), D = r.strictNullHandling ? null : "") : (E = r.decoder(p.slice(0, h), le.decoder, u, "key"), D = er.maybeMap(
        Tl(p.slice(h + 1), r),
        function(I) {
          return r.decoder(I, le.decoder, u, "value");
        }
      )), D && r.interpretNumericEntities && u === "iso-8859-1" && (D = Oh(D)), p.indexOf("[]=") > -1 && (D = Nh(D) ? [D] : D), Ko.call(n, E) ? n[E] = er.combine(n[E], D) : n[E] = D;
    }
  return n;
}, Mh = function(e, t, r, n) {
  for (var o = n ? t : Tl(t, r), i = e.length - 1; i >= 0; --i) {
    var s, a = e[i];
    if (a === "[]" && r.parseArrays)
      s = [].concat(o);
    else {
      s = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var l = a.charAt(0) === "[" && a.charAt(a.length - 1) === "]" ? a.slice(1, -1) : a, u = parseInt(l, 10);
      !r.parseArrays && l === "" ? s = { 0: o } : !isNaN(u) && a !== l && String(u) === l && u >= 0 && r.parseArrays && u <= r.arrayLimit ? (s = [], s[u] = o) : l !== "__proto__" && (s[l] = o);
    }
    o = s;
  }
  return o;
}, Ih = function(t, r, n, o) {
  if (!!t) {
    var i = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, s = /(\[[^[\]]*])/, a = /(\[[^[\]]*])/g, l = n.depth > 0 && s.exec(i), u = l ? i.slice(0, l.index) : i, p = [];
    if (u) {
      if (!n.plainObjects && Ko.call(Object.prototype, u) && !n.allowPrototypes)
        return;
      p.push(u);
    }
    for (var f = 0; n.depth > 0 && (l = a.exec(i)) !== null && f < n.depth; ) {
      if (f += 1, !n.plainObjects && Ko.call(Object.prototype, l[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      p.push(l[1]);
    }
    return l && p.push("[" + i.slice(l.index) + "]"), Mh(p, r, n, o);
  }
}, xh = function(t) {
  if (!t)
    return le;
  if (t.decoder !== null && t.decoder !== void 0 && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof t.charset > "u" ? le.charset : t.charset;
  return {
    allowDots: typeof t.allowDots > "u" ? le.allowDots : !!t.allowDots,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : le.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : le.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : le.arrayLimit,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : le.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : le.comma,
    decoder: typeof t.decoder == "function" ? t.decoder : le.decoder,
    delimiter: typeof t.delimiter == "string" || er.isRegExp(t.delimiter) ? t.delimiter : le.delimiter,
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : le.depth,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : le.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : le.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : le.plainObjects,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : le.strictNullHandling
  };
}, Sh = function(e, t) {
  var r = xh(t);
  if (e === "" || e === null || typeof e > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof e == "string" ? Dh(e, r) : e, o = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(n), s = 0; s < i.length; ++s) {
    var a = i[s], l = Ih(a, n[a], r, typeof e == "string");
    o = er.merge(o, l, r);
  }
  return r.allowSparse === !0 ? o : er.compact(o);
}, _h = Ah, Th = Sh, Ph = Ci, Pl = {
  formats: Ph,
  parse: Th,
  stringify: _h
};
const Rh = (e) => ({
  async view() {
    const { data: t } = await e.get("//openhome.bilibili.com/arcopen/user/company/view");
    return t == null ? void 0 : t.data;
  }
});
function Rl(e) {
  return decodeURIComponent(
    document.cookie.replace(
      new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(e).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"),
      "$1"
    )
  ) || null;
}
const jh = (e) => ({
  async info() {
    const { data: t } = await e.get("//api.bilibili.com/x/web-interface/nav");
    return t.code === 0 && t.data && t.data.isLogin ? t.data : t;
  },
  async getArcUserInfo() {
    const { data: t } = await e.get("//openhome.bilibili.com/arcopen/user/account/info");
    if (t.code === 0)
      return t.data;
    throw new Error(t.message);
  },
  async logout() {
    const { data: t } = await yl.post("//passport.bilibili.com/login/exit/v2", Pl.stringify({
      biliCSRF: Rl("bili_jct")
    }), {
      withCredentials: !0
    });
    if (t.code === 0)
      location.reload();
    else
      throw new Error("\u767B\u51FA\u5931\u8D25");
  },
  async passportInfo() {
    const { data: t } = await e.get("//passport.bilibili.com/web/site/user/info");
    return t.code === 0 ? t.data : null;
  },
  async getMessage() {
    const { data: t } = await e.get("//openhome.bilibili.com/arcopen/user/msg/cnt");
    if (t.code === 0)
      return t.data;
    throw new Error(t.message);
  },
  async getMessageList(t) {
    const { data: r } = await e.get("//openhome.bilibili.com/arcopen/user/msg/list", { params: t });
    if (r.code === 0)
      return r.data;
    throw new Error(r.message);
  },
  async getSingleUnread() {
    const { data: t } = await e.get("//api.vc.bilibili.com/session_svr/v1/session_svr/single_unread?unread_type=0&build=0&mobi_app=web");
    if (t.code === 0)
      return t.data;
    throw new Error(t.message);
  }
}), pn = yl.create({
  timeout: 5e3
});
pn.interceptors.request.use(function(e) {
  return e.params || (e.params = {}), e.params = {
    ...e.params,
    n_ts: Date.now()
  }, e.withCredentials = !0, e.headers || (e.headers = {}), e.method !== "get" && (e.data = e.data || {}, e.data.csrf = Rl("bili_jct")), e.data && e.not_json && (e.data = Pl.stringify(e.data)), e;
}, function(e) {
  return Promise.reject(e);
});
pn.interceptors.response.use(function(e) {
  return e;
}, function(e) {
  return e.message.indexOf("timeout") !== -1 ? Promise.reject(new Error("\u5F53\u524D\u73AF\u5883\u7F51\u7EDC\u8FC7\u6162\uFF0C\u8BF7\u6C42\u8D85\u65F6!")) : e.message.indexOf("Network") !== -1 ? Promise.reject(new Error("\u7F51\u7EDC\u9519\u8BEF")) : Promise.reject(e);
});
const yt = {
  user: jh(pn),
  company: Rh(pn)
};
function Gs() {
  if (window.biliQuickLogin)
    window.biliQuickLogin(async () => {
      window.location.reload();
    });
  else {
    const e = document.createElement("script");
    e.src = "//static.hdslb.com/account/bili_quick_login.js", e.onload = function() {
      window.biliQuickLogin(async () => {
        window.location.reload();
      });
    }, document.body.appendChild(e);
  }
}
const Vh = gc({
  name: "OptHeader",
  setup() {
    const e = ir(!1), t = ir({
      isLogin: !1,
      uid: 0,
      uname: "",
      face: "",
      avatar: "",
      role: "",
      backgroundImage: "",
      username: ""
    }), r = ir({ state: null }), n = ir({
      level: 0
    }), o = Je(() => {
      var N;
      return (N = t.value) == null ? void 0 : N.avatar;
    }), i = Je(() => {
      var N;
      return (N = t.value) == null ? void 0 : N.username;
    }), s = Je(() => {
      var N;
      return (N = t.value) == null ? void 0 : N.role;
    }), a = Je(() => {
      var N;
      return (N = t.value) == null ? void 0 : N.backgroundImage;
    }), l = ir(0), u = Je(() => window.location.pathname), p = Je(() => window.location.hostname.indexOf("openhome") > -1), f = Je(() => {
      var _;
      const N = {
        1: "[\u7BA1\u7406\u5458]",
        20: "[\u7BA1\u7406\u5458]",
        30: "[\u5F00\u53D1\u8005]",
        100: ""
      };
      return n.value && N[(_ = n.value) == null ? void 0 : _.level];
    }), h = (N) => {
      window.open("//" + N, "_self");
    }, E = async () => {
      localStorage.removeItem("arcopenComanyAddInfo"), await yt.user.logout(), window.location.reload();
    }, D = () => {
      Gs(), Fr.sendCustomEvent("openplat_register_click");
    }, I = Je(() => {
      var N;
      if ((N = r.value) != null && N.state) {
        if (r.value.state === 0)
          return '<span style="background-color: #FAAB4B;">\u5BA1\u6838\u4E2D</span>';
        if (r.value.state === 1)
          return "<span>\u901A\u8FC7</span>";
        if (r.value.state === 2)
          return '<span style="background-color: #FA5A57;">\u9A73\u56DE</span>';
      } else
        return '<span style="background-color: #FAAB4B;">\u672A\u8BA4\u8BC1</span>';
    }), L = () => {
      Fr.sendCustomEvent("openplat_message_click"), l.value = 0;
    }, x = () => {
      Gs(), Fr.sendCustomEvent("openplat_login_click");
    }, K = (N) => N ? N.replace(/^https?:/, "") : "", j = async () => {
      try {
        if (p.value) {
          const [N, _, ae, G] = await Promise.all([
            yt.user.info(),
            yt.company.view(),
            yt.user.getArcUserInfo(),
            yt.user.getMessage()
          ]);
          t.value = N, r.value = _, n.value = ae, l.value = G;
        } else {
          const [N, _] = await Promise.all([
            yt.user.info(),
            yt.user.getSingleUnread()
          ]);
          t.value = N, l.value = Object.values(_).reduce((ae, G) => ae + G, 0);
        }
      } catch (N) {
        console.log(N);
      }
    };
    return La(async () => {
      await j();
    }), {
      userInfo: t,
      showDetail: e,
      avatar: o,
      username: i,
      role: s,
      backgroundImage: a,
      num: l,
      getRole: f,
      logReport: Fr,
      login: x,
      register: D,
      jumpToMessage: L,
      logout: E,
      replaceHTTPResource: K,
      onJumpUrl: h,
      renderCompanyState: I,
      currentRoute: u,
      isOpenPlatform: p
    };
  }
}), Fh = "data:image/png;base64,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", Bh = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjbGFzcz0iemh1emhhbi1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuNzMyNTIgMi42NzA5NEMzLjMzMjI5IDIuMjg0ODQgMy4zMzIyOSAxLjY0MzczIDMuNzMyNTIgMS4yNTc2NEM0LjExMjkxIDAuODkwNjg0IDQuNzE1NTIgMC44OTA2ODQgNS4wOTU5MSAxLjI1NzY0TDcuMjE3MjMgMy4zMDQwM0M3LjI3NzQ5IDMuMzYyMTggNy4zMjg2OSAzLjQyNjEgNy4zNzA4MSAzLjQ5NDA3SDEwLjU3ODlDMTAuNjIxMSAzLjQyNjEgMTAuNjcyMyAzLjM2MjE4IDEwLjczMjUgMy4zMDQwM0wxMi44NTM4IDEuMjU3NjRDMTMuMjM0MiAwLjg5MDY4NCAxMy44MzY4IDAuODkwNjg0IDE0LjIxNzIgMS4yNTc2NEMxNC42MTc1IDEuNjQzNzMgMTQuNjE3NSAyLjI4NDg0IDE0LjIxNzIgMi42NzA5NEwxMy4zNjQgMy40OTQwN0gxNEMxNi4yMDkxIDMuNDk0MDcgMTggNS4yODQ5MyAxOCA3LjQ5NDA3VjEyLjk5OTZDMTggMTUuMjA4NyAxNi4yMDkxIDE2Ljk5OTYgMTQgMTYuOTk5Nkg0QzEuNzkwODYgMTYuOTk5NiAwIDE1LjIwODcgMCAxMi45OTk2VjcuNDk0MDZDMCA1LjI4NDkyIDEuNzkwODYgMy40OTQwNyA0IDMuNDk0MDdINC41ODU3OUwzLjczMjUyIDIuNjcwOTRaTTQgNS40MjM0M0MyLjg5NTQzIDUuNDIzNDMgMiA2LjMxODg2IDIgNy40MjM0M1YxMy4wNzAyQzIgMTQuMTc0OCAyLjg5NTQzIDE1LjA3MDIgNCAxNS4wNzAySDE0QzE1LjEwNDYgMTUuMDcwMiAxNiAxNC4xNzQ4IDE2IDEzLjA3MDJWNy40MjM0M0MxNiA2LjMxODg2IDE1LjEwNDYgNS40MjM0MyAxNCA1LjQyMzQzSDRaTTUgOS4zMTc0N0M1IDguNzY1MTkgNS40NDc3MiA4LjMxNzQ3IDYgOC4zMTc0N0M2LjU1MjI4IDguMzE3NDcgNyA4Ljc2NTE5IDcgOS4zMTc0N1YxMC4yMTE1QzcgMTAuNzYzOCA2LjU1MjI4IDExLjIxMTUgNiAxMS4yMTE1QzUuNDQ3NzIgMTEuMjExNSA1IDEwLjc2MzggNSAxMC4yMTE1VjkuMzE3NDdaTTEyIDguMzE3NDdDMTEuNDQ3NyA4LjMxNzQ3IDExIDguNzY1MTkgMTEgOS4zMTc0N1YxMC4yMTE1QzExIDEwLjc2MzggMTEuNDQ3NyAxMS4yMTE1IDEyIDExLjIxMTVDMTIuNTUyMyAxMS4yMTE1IDEzIDEwLjc2MzggMTMgMTAuMjExNVY5LjMxNzQ3QzEzIDguNzY1MTkgMTIuNTUyMyA4LjMxNzQ3IDEyIDguMzE3NDdaIiBmaWxsPSJjdXJyZW50Q29sb3IiPjwvcGF0aD48L3N2Zz4=", Lh = "data:image/svg+xml;base64,PHN2ZyB0PSIxNjk4MTM5MjcwMDQ2IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE0NDAiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48cGF0aCBkPSJNNTczLjA1NiA3NTJsMzA4LjgtNDA0LjYwOEE3Ni44IDc2LjggMCAwIDAgODIwLjczNiAyMjRIMjAzLjIzMmE3Ni44IDc2LjggMCAwIDAtNjEuMDU2IDEyMy4zOTJsMzA4LjggNDA0LjYwOGE3Ni44IDc2LjggMCAwIDAgMTIyLjA4IDB6IiBmaWxsPSIjMDAwMDAwIiBwLWlkPSIxNDQxIj48L3BhdGg+PC9zdmc+", kh = "data:image/png;base64,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";
const zh = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Pe = (e) => (ic("data-v-1c3c65ed"), e = e(), sc(), e), Uh = {
  class: "arcopen-nav",
  ref: "nav"
}, Hh = { class: "arcopen-nav-center" }, qh = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("div", { class: "zhuzhan-redirect arcopen-pointer" }, [
  /* @__PURE__ */ T("img", { src: Bh }),
  /* @__PURE__ */ T("span", { class: "arcopen-vertical" }, "\u4E3B\u7AD9")
], -1)), Wh = [
  qh
], Kh = { class: "arcopen-link-group" }, Yh = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("span", null, "\u5F00\u5E73\u7BA1\u7406\u4E2D\u5FC3", -1)), Qh = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("img", {
  class: "arcopen-vertical pointer-down",
  src: Lh
}, null, -1)), Jh = { class: "group-top-link" }, Xh = {
  key: 0,
  class: "arcopen-user-info arcopen-pointer"
}, Zh = { class: "user-avatar" }, $h = ["src"], Gh = { class: "user-name" }, em = { class: "user-role" }, tm = { class: "user-detail" }, rm = { class: "user-detail-center" }, nm = { class: "user-detail-face" }, om = ["src"], im = { class: "user-detail-name" }, sm = { class: "user-detail-role" }, am = { class: "role" }, lm = ["innerHTML"], um = { class: "user-detail-bottom" }, cm = { key: 0 }, fm = { class: "user-detail-bottom-message" }, pm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("i", { class: "message-icon identity" }, null, -1)), dm = { class: "user-detail-bottom-message" }, hm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("i", { class: "message-icon" }, null, -1)), mm = { key: 0 }, gm = { key: 1 }, ym = { class: "user-detail-bottom-message" }, vm = { class: "user-detail-bottom-message" }, Em = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("i", { class: "message-icon" }, null, -1)), bm = { key: 0 }, Am = { class: "user-detail-bottom-message" }, Nm = { class: "user-detail-bottom-message" }, Om = { class: "user-detail-bottom-message" }, wm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("i", { class: "message-icon logout" }, null, -1)), Cm = {
  key: 1,
  class: "arcopen-user-login"
}, Dm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("img", {
  src: kh,
  alt: ""
}, null, -1)), Mm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("span", null, "\u767B\u5F55", -1)), Im = [
  Dm,
  Mm
], xm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("div", { class: "split" }, "|", -1)), Sm = /* @__PURE__ */ Pe(() => /* @__PURE__ */ T("div", { class: "register arcopen-pointer" }, "\u6CE8\u518C", -1)), _m = [
  Sm
];
function Tm(e, t, r, n, o, i) {
  var s;
  return Qe(), rt("div", Uh, [
    T("div", Hh, [
      T("img", {
        src: Fh,
        alt: "logo",
        class: "arcopen-logo",
        onClick: t[0] || (t[0] = (a) => e.onJumpUrl("openhome.bilibili.com"))
      }),
      T("a", {
        href: "//www.bilibili.com",
        target: "_blank",
        onClick: t[1] || (t[1] = (a) => e.logReport.sendCustomEvent("openplat_bilibili_click"))
      }, Wh),
      T("div", Kh, [
        T("span", {
          class: xe(["top-link", { "top-link-active": e.isOpenPlatform && e.currentRoute === "/" }]),
          onClick: [
            t[2] || (t[2] = (a) => e.onJumpUrl("openhome.bilibili.com")),
            t[3] || (t[3] = (a) => e.logReport.sendCustomEvent("openplat_homepage_click"))
          ]
        }, "\u5F00\u653E\u5E73\u53F0 ", 2),
        T("span", {
          onClick: [
            t[4] || (t[4] = (a) => e.onJumpUrl("openhome.bilibili.com/doc")),
            t[5] || (t[5] = (a) => e.logReport.sendCustomEvent("openplat_filecenter_click"))
          ],
          class: xe(["top-link", { "top-link-active": e.currentRoute === "/doc" }])
        }, " \u5F00\u5E73\u6587\u6863\u4E2D\u5FC3 ", 2),
        T("span", {
          class: xe(["top-link", { "top-link-active": e.currentRoute.indexOf("company-core") > -1 || e.currentRoute.indexOf("auth") > -1 }])
        }, [
          Yh,
          Qh,
          T("span", Jh, [
            T("span", {
              onClick: [
                t[6] || (t[6] = (a) => e.onJumpUrl("openhome.bilibili.com/company-core/account")),
                t[7] || (t[7] = (a) => e.logReport.sendCustomEvent("openplat_accountmanage_click"))
              ],
              class: xe(["group-item"])
            }, "\u8D26\u53F7\u7BA1\u7406 "),
            T("span", {
              onClick: [
                t[8] || (t[8] = (a) => e.onJumpUrl("openhome.bilibili.com/company-core")),
                t[9] || (t[9] = (a) => e.logReport.sendCustomEvent("openplat_appmanage_click"))
              ],
              class: xe([" group-item"])
            }, "\u5E94\u7528\u7BA1\u7406 "),
            T("span", {
              onClick: [
                t[10] || (t[10] = (a) => e.onJumpUrl("openhome.bilibili.com/auth")),
                t[11] || (t[11] = (a) => e.logReport.sendCustomEvent("auth_manage_click"))
              ],
              class: xe(["group-item"])
            }, "\u6388\u6743\u7BA1\u7406 ")
          ])
        ], 2),
        T("span", {
          onClick: t[12] || (t[12] = (a) => e.onJumpUrl("open-live.bilibili.com/")),
          class: xe(["top-link", { "top-link-active": !e.isOpenPlatform }])
        }, " \u76F4\u64AD\u521B\u4F5C\u8005\u670D\u52A1\u4E2D\u5FC3 ", 2),
        T("span", {
          class: xe(["top-link"]),
          onClick: t[13] || (t[13] = (a) => e.onJumpUrl("play-live.bilibili.com"))
        }, " \u4E92\u52A8\u73A9\u6CD5 ")
      ]),
      e.userInfo.isLogin ? (Qe(), rt("div", Xh, [
        T("div", Zh, [
          T("img", {
            src: e.replaceHTTPResource(e.userInfo.face),
            alt: ""
          }, null, 8, $h)
        ]),
        T("p", Gh, Ft(e.userInfo.uname), 1),
        T("p", em, Ft(e.getRole), 1),
        T("div", tm, [
          T("div", {
            class: "user-detail-top",
            style: gn({ backgroundImage: `url(${e.replaceHTTPResource((s = e.userInfo) == null ? void 0 : s.face)})` })
          }, null, 4),
          T("div", rm, [
            T("div", nm, [
              T("img", {
                src: e.replaceHTTPResource(e.userInfo.face),
                alt: ""
              }, null, 8, om)
            ]),
            T("p", im, Ft(e.userInfo.uname), 1),
            T("p", sm, [
              T("span", am, Ft(e.isOpenPlatform ? "\u5F00\u653E\u5E73\u53F0-\u4F01\u4E1A\u5F00\u53D1\u8005" : "\u76F4\u64AD\u521B\u4F5C\u8005\u670D\u52A1\u4E2D\u5FC3"), 1),
              e.isOpenPlatform ? (Qe(), rt("span", {
                key: 0,
                class: "vip",
                innerHTML: e.renderCompanyState
              }, null, 8, lm)) : zn("", !0)
            ])
          ]),
          T("div", um, [
            e.isOpenPlatform ? (Qe(), rt("div", cm, [
              T("div", fm, [
                pm,
                T("span", {
                  onClick: [
                    t[14] || (t[14] = (a) => e.onJumpUrl("openhome.bilibili.com/company/add")),
                    t[15] || (t[15] = (a) => e.logReport.sendCustomEvent("openplat_myinformation_click"))
                  ],
                  class: "message-content"
                }, "\u6211\u7684\u8D44\u6599 ")
              ]),
              T("div", dm, [
                hm,
                T("span", {
                  onClick: [
                    t[16] || (t[16] = (a) => e.onJumpUrl("openhome.bilibili.com/message")),
                    t[17] || (t[17] = (...a) => e.jumpToMessage && e.jumpToMessage(...a))
                  ],
                  class: "message-content msg"
                }, [
                  jo("\u6D88\u606F\u4E2D\u5FC3 "),
                  e.num ? (Qe(), rt("p", mm, Ft(e.num), 1)) : zn("", !0)
                ])
              ])
            ])) : (Qe(), rt("div", gm, [
              T("div", ym, [
                T("span", {
                  onClick: t[18] || (t[18] = (a) => e.onJumpUrl("open-live.bilibili.com/open-manage")),
                  class: "message-content text-indent-3em"
                }, "\u670D\u52A1\u4E2D\u5FC3 ")
              ]),
              T("div", vm, [
                Em,
                T("span", {
                  onClick: t[19] || (t[19] = (a) => e.onJumpUrl("message.bilibili.com/?from_workshop=1")),
                  class: "message-content msg"
                }, [
                  jo("\u6D88\u606F\u4E2D\u5FC3 "),
                  e.num ? (Qe(), rt("p", bm, Ft(e.num > 99 ? "99+" : e.num), 1)) : zn("", !0)
                ])
              ]),
              T("div", Am, [
                T("span", {
                  onClick: t[20] || (t[20] = (a) => e.onJumpUrl("play-live.bilibili.com/my-app")),
                  class: "message-content text-indent-3em"
                }, "\u6211\u7684\u5DE5\u5177\u5E93 ")
              ]),
              T("div", Nm, [
                T("span", {
                  onClick: t[21] || (t[21] = (a) => e.onJumpUrl("//service.bilibili.com/v2/chat/pc/index.html?sysNum=102d1b48515346ec8e9fb543b54ec454&groupId=576259b9c16845f4975d9bb0604c785f&robotFlag=35")),
                  class: "message-content text-indent-3em"
                }, "\u8054\u7CFB\u5BA2\u670D ")
              ])
            ])),
            T("div", Om, [
              wm,
              T("span", {
                class: "message-content",
                onClick: t[22] || (t[22] = (...a) => e.logout && e.logout(...a))
              }, "\u9000\u51FA\u8D26\u53F7")
            ])
          ])
        ])
      ])) : (Qe(), rt("div", Cm, [
        T("div", {
          class: "login arcopen-pointer",
          onClick: t[23] || (t[23] = (...a) => e.login && e.login(...a))
        }, Im),
        xm,
        T("div", {
          onClick: t[24] || (t[24] = (a) => e.register())
        }, _m)
      ]))
    ])
  ], 512);
}
const Pm = /* @__PURE__ */ zh(Vh, [["render", Tm], ["__scopeId", "data-v-1c3c65ed"]]);
var Jt;
class jm {
  constructor() {
    _i(this, Jt, void 0);
    Ti(this, Jt, Hf(Pm));
  }
  mount(t) {
    Vn(this, Jt).mount(t);
  }
  destroy() {
    Vn(this, Jt).unmount();
  }
}
Jt = new WeakMap();
export {
  jm as EsOptHeader
};
